export const watchesFakePlpData = {
  hits: [
    {
      name_en: 'Endurance Pro',
      model_en: 'Endurance Pro',
      case_en: 'Breitlight®',
      dial_color_en: 'Black',
      type_en: ['Men', 'Women', 'Professional'],
      com_trace_story_en: null,
      pdp_release_ts: 1745829000,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1745829000,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1745829000,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1745829000,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDY5OQ==',
      product_id: 'UHJvZHVjdDo0OTI5',
      name: {
        EN_US: 'Endurance Pro 44',
        ES: 'Endurance Pro 44',
        ZH_HANS: '专业耐力腕表44（Endurance Pro 44）',
      },
      product_type: 'Watch',
      ecomm_available: false,
      phone_sale_available: true,
      price: 3400.0,
      price_range: '0-5999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/x82310a51b1s2-soldier_95d31fb4_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/x82310a51b1s2-soldier_95d31fb4.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1720617943,
      launch_date: 1719878400,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-<None>',
      model: {
        name: {
          EN_US: 'Endurance Pro',
          ES: 'Endurance Pro',
          ZH_HANS: '专业耐力腕表（Endurance Pro）',
        },
        slug: 'endurance-pro',
      },
      type: {
        EN_US: ['Men', 'Women', 'Professional'],
        ES: ['Hombre', 'Mujer', 'Profesional'],
        ZH_HANS: ['男士', '女士', '专业'],
      },
      universe: 'Professional',
      head_reference: null,
      size: 44.0,
      size_range: '44-45',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/x82310a51b1s2-on-wrist_a5b8ed4a.png',
      collections: [
        {
          name: 'Professional',
          slug: 'professional',
          id: 'Q29sbGVjdGlvbjo3OQ==',
        },
      ],
      collection: 'Professional',
      collection_id: 'Q29sbGVjdGlvbjo3OQ==',
      com_trace_story: null,
      case: {
        EN_US: 'Breitlight® | BREITL',
        ES: 'Breitlight® | BREITL',
        ZH_HANS: 'Breitlight® | BREITL',
      },
      dial_color: {
        EN_US: 'Black | V-DIAL-COLOR-5686',
        ES: 'Negro | V-DIAL-COLOR-5686',
        ZH_HANS: '黑色 | V-DIAL-COLOR-5686',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:34:12',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1745829000,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'X82310A51B1S2',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Endurance Pro 44',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Endurance Pro 44',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '专业耐力腕表44（Endurance Pro 44）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Professional',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Professional',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Breitlight® | BREITL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Breitlight® | BREITL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: 'Breitlight® | BREITL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Black | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Negro | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '黑色 | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Superocean Automatic 36',
      model_en: 'Superocean Automatic 36 (MY22)',
      case_en: 'Stainless steel & 18k red gold',
      dial_color_en: 'White',
      type_en: ['Men', 'Women'],
      com_trace_story_en: null,
      pdp_release_ts: 1746482400,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1746482400,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1746482400,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1746482400,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDY5NQ==',
      product_id: 'UHJvZHVjdDo0OTI1',
      name: {
        EN_US: 'Superocean Automatic 36',
        ES: 'Superocean Automatic 36',
        ZH_HANS: '超级海洋自动机械腕表36（Superocean Automatic 36）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 7300.0,
      price_range: '6000-8999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/u17377211a1s1-soldier_ffe3140d_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/u17377211a1s1-soldier_ffe3140d.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1723139883,
      launch_date: 1718150400,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-U1737721/A860',
      model: {
        name: {
          EN_US: 'Superocean Automatic 36 (MY22)',
          ES: 'Superocean Automatic 36 (MY22)',
          ZH_HANS: '超级海洋自动机械腕表36（Superocean Automatic 36）',
        },
        slug: 'superocean-automatic-36-my22',
      },
      type: {
        EN_US: ['Men', 'Women'],
        ES: ['Hombre', 'Mujer'],
        ZH_HANS: ['男士', '女士'],
      },
      universe: 'SEA',
      head_reference: 'U1737721/A860',
      size: 36.0,
      size_range: '36-37',
      collections: [
        {
          name: 'Superocean',
          slug: 'superocean',
          id: 'Q29sbGVjdGlvbjo3NQ==',
        },
      ],
      collection: 'Superocean',
      collection_id: 'Q29sbGVjdGlvbjo3NQ==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel & 18k red gold | STNSTL_18KREG',
        ES: 'Acero inoxidable y oro rojo de 18K | STNSTL_18KREG',
        ZH_HANS: '精钢和18K红金 | STNSTL_18KREG',
      },
      dial_color: {
        EN_US: 'White | V-DIAL-COLOR-5926',
        ES: 'Blanco | V-DIAL-COLOR-5926',
        ZH_HANS: '白色 | V-DIAL-COLOR-5926',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        attrs_without_value: ['image_wrist_url'],
        updated_at_utc: '2025-05-09 18:59:28',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1718186400,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'U17377211A1S1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Superocean Automatic 36',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Superocean Automatic 36',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '超级海洋自动机械腕表36（Superocean Automatic 36）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Superocean',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Superocean',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel & 18k red gold | STNSTL_18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable y oro rojo de 18K | STNSTL_18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢和18K红金 | STNSTL_18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'White | V-DIAL-COLOR-5926',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Blanco | V-DIAL-COLOR-5926',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '白色 | V-DIAL-COLOR-5926',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Chronomat B01 42',
      model_en: 'Chronomat B01 42',
      case_en: 'Stainless steel',
      dial_color_en: 'Silver',
      type_en: ['Men', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1717668000,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1717668000,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1717668000,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1717668000,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDczOQ==',
      product_id: 'UHJvZHVjdDo0OTcw',
      name: {
        EN_US: 'Chronomat B01 42',
        ES: 'Chronomat B01 42',
        ZH_HANS: '机械计时B01计时腕表42（Chronomat B01 42）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 8550.0,
      price_range: '6000-8999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/ab0134101g1s2-soldier_4485311f_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0134101g1s2-soldier_4485311f.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1720617831,
      launch_date: 1717632000,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-AB013410/G865',
      model: {
        name: {
          EN_US: 'Chronomat B01 42',
          ES: 'Chronomat B01 42',
          ZH_HANS: '机械计时B01计时腕表42（Chronomat B01 42）',
        },
        slug: 'chronomat-b01-42',
      },
      type: {
        EN_US: ['Men', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '百年灵自制机芯'],
      },
      universe: 'LAND',
      head_reference: 'AB013410/G865',
      size: 42.0,
      size_range: '42-43',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0134101g1s2-on-wrist_7228078a.png',
      collections: [
        {
          name: 'Chronomat',
          slug: 'chronomat',
          id: 'Q29sbGVjdGlvbjo3Ng==',
        },
      ],
      collection: 'Chronomat',
      collection_id: 'Q29sbGVjdGlvbjo3Ng==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Silver | V-DIAL-COLOR-5843',
        ES: 'Plata | V-DIAL-COLOR-5843',
        ZH_HANS: '银色 | V-DIAL-COLOR-5843',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:30:04',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1717668000,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'AB0134101G1S2',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Chronomat B01 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Chronomat B01 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '机械计时B01计时腕表42（Chronomat B01 42）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Chronomat',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Chronomat',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Silver | V-DIAL-COLOR-5843',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Plata | V-DIAL-COLOR-5843',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '银色 | V-DIAL-COLOR-5843',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Chronomat B01 42',
      model_en: 'Chronomat B01 42',
      case_en: '18k red gold',
      dial_color_en: 'Green',
      type_en: ['Men', 'Gold', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1741708800,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1717495200,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1717495200,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1717495200,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDc0Ng==',
      product_id: 'UHJvZHVjdDo0OTc3',
      name: {
        EN_US: 'Chronomat B01 42',
        ES: 'Chronomat B01 42',
        ZH_HANS: '机械计时B01计时腕表42（Chronomat B01 42）',
      },
      product_type: 'Watch',
      ecomm_available: false,
      phone_sale_available: true,
      price: 23000.0,
      price_range: '12000-inf',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/rb0134101l1s1-soldier_a94ede36_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/rb0134101l1s1-soldier_a94ede36.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1720617901,
      launch_date: 1717459200,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-RB013410/L617',
      model: {
        name: {
          EN_US: 'Chronomat B01 42',
          ES: 'Chronomat B01 42',
          ZH_HANS: '机械计时B01计时腕表42（Chronomat B01 42）',
        },
        slug: 'chronomat-b01-42',
      },
      type: {
        EN_US: ['Men', 'Gold', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'Oro', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '金质', '百年灵自制机芯'],
      },
      universe: 'LAND',
      head_reference: 'RB013410/L617',
      size: 42.0,
      size_range: '42-43',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/rb0134101l1s1-on-wrist_9375e63c.png',
      collections: [
        {
          name: 'Chronomat',
          slug: 'chronomat',
          id: 'Q29sbGVjdGlvbjo3Ng==',
        },
      ],
      collection: 'Chronomat',
      collection_id: 'Q29sbGVjdGlvbjo3Ng==',
      com_trace_story: null,
      case: {
        EN_US: '18k red gold | 18KREG',
        ES: 'Oro rojo de 18K | 18KREG',
        ZH_HANS: '18K红金 | 18KREG',
      },
      dial_color: {
        EN_US: 'Green | V-DIAL-COLOR-5765',
        ES: 'Verde | V-DIAL-COLOR-5765',
        ZH_HANS: '绿色 | V-DIAL-COLOR-5765',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:31:20',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1741708800,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'RB0134101L1S1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Chronomat B01 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Chronomat B01 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '机械计时B01计时腕表42（Chronomat B01 42）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Chronomat',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Chronomat',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: '18k red gold | 18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Oro rojo de 18K | 18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '18K红金 | 18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Green | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Verde | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '绿色 | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Chronomat B01 42',
      model_en: 'Chronomat B01 42',
      case_en: 'Stainless steel & platinum',
      dial_color_en: 'Ice blue',
      type_en: ['Men', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1717495200,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1717495200,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1717495200,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1717495200,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDc0MA==',
      product_id: 'UHJvZHVjdDo0OTcx',
      name: {
        EN_US: 'Chronomat B01 42',
        ES: 'Chronomat B01 42',
        ZH_HANS: '机械计时B01计时腕表42（Chronomat B01 42）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 11250.0,
      price_range: '10000-11999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/pb0134101c1s2-soldier_767c169e_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/pb0134101c1s2-soldier_767c169e.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1720617877,
      launch_date: 1717459200,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-PB013410/CB02',
      model: {
        name: {
          EN_US: 'Chronomat B01 42',
          ES: 'Chronomat B01 42',
          ZH_HANS: '机械计时B01计时腕表42（Chronomat B01 42）',
        },
        slug: 'chronomat-b01-42',
      },
      type: {
        EN_US: ['Men', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '百年灵自制机芯'],
      },
      universe: 'LAND',
      head_reference: 'PB013410/CB02',
      size: 42.0,
      size_range: '42-43',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/pb0134101c1s2-on-wrist_36d42501.png',
      collections: [
        {
          name: 'Chronomat',
          slug: 'chronomat',
          id: 'Q29sbGVjdGlvbjo3Ng==',
        },
      ],
      collection: 'Chronomat',
      collection_id: 'Q29sbGVjdGlvbjo3Ng==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel & platinum | SS_PLAT',
        ES: 'Acero inoxidable y platino | SS_PLAT',
        ZH_HANS: '精钢间铂金 | SS_PLAT',
      },
      dial_color: {
        EN_US: 'Ice blue | V-DIAL-COLOR-1111',
        ES: 'Azul hielo | V-DIAL-COLOR-1111',
        ZH_HANS: '冰蓝 | V-DIAL-COLOR-1111',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:30:03',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1717495200,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'PB0134101C1S2',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Chronomat B01 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Chronomat B01 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '机械计时B01计时腕表42（Chronomat B01 42）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Chronomat',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Chronomat',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel & platinum | SS_PLAT',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable y platino | SS_PLAT',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢间铂金 | SS_PLAT',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Ice blue | V-DIAL-COLOR-1111',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Azul hielo | V-DIAL-COLOR-1111',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '冰蓝 | V-DIAL-COLOR-1111',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Chronomat B01 42',
      model_en: 'Chronomat B01 42',
      case_en: 'Stainless steel',
      dial_color_en: 'Copper',
      type_en: ['Men', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1717495200,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1717495200,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1717495200,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1717495200,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDc0MQ==',
      product_id: 'UHJvZHVjdDo0OTcy',
      name: {
        EN_US: 'Chronomat B01 42',
        ES: 'Chronomat B01 42',
        ZH_HANS: '机械计时B01计时腕表42（Chronomat B01 42）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 8550.0,
      price_range: '6000-8999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/ab0134101k1s1-soldier_578f0eb7_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0134101k1s1-soldier_578f0eb7.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1720617829,
      launch_date: 1717459200,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-AB013410/K533',
      model: {
        name: {
          EN_US: 'Chronomat B01 42',
          ES: 'Chronomat B01 42',
          ZH_HANS: '机械计时B01计时腕表42（Chronomat B01 42）',
        },
        slug: 'chronomat-b01-42',
      },
      type: {
        EN_US: ['Men', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '百年灵自制机芯'],
      },
      universe: 'LAND',
      head_reference: 'AB013410/K533',
      size: 42.0,
      size_range: '42-43',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0134101k1s1-on-wrist_b35903a5.png',
      collections: [
        {
          name: 'Chronomat',
          slug: 'chronomat',
          id: 'Q29sbGVjdGlvbjo3Ng==',
        },
      ],
      collection: 'Chronomat',
      collection_id: 'Q29sbGVjdGlvbjo3Ng==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Copper | V-DIAL-COLO-999',
        ES: 'Cobre | V-DIAL-COLO-999',
        ZH_HANS: '铜色 | V-DIAL-COLO-999',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:28:45',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1717495200,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'AB0134101K1S1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Chronomat B01 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Chronomat B01 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '机械计时B01计时腕表42（Chronomat B01 42）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Chronomat',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Chronomat',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Copper | V-DIAL-COLO-999',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Cobre | V-DIAL-COLO-999',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '铜色 | V-DIAL-COLO-999',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Chronomat B01 42',
      model_en: 'Chronomat B01 42',
      case_en: 'Titanium',
      dial_color_en: 'Anthracite',
      type_en: ['Men', 'Titanium', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1712138400,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1712138400,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1712138400,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1712138400,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDYzMg==',
      product_id: 'UHJvZHVjdDo0ODYw',
      name: {
        EN_US: 'Chronomat B01 42',
        ES: 'Chronomat B01 42',
        ZH_HANS: '机械计时B01计时腕表42（Chronomat B01 42）',
      },
      product_type: 'Watch',
      ecomm_available: false,
      phone_sale_available: true,
      price: 12400.0,
      price_range: '12000-inf',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/eb0134101m1e1-soldier_d86f3cba_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/eb0134101m1e1-soldier_d86f3cba.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1720617872,
      launch_date: 1712102400,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-EB013410/M549',
      model: {
        name: {
          EN_US: 'Chronomat B01 42',
          ES: 'Chronomat B01 42',
          ZH_HANS: '机械计时B01计时腕表42（Chronomat B01 42）',
        },
        slug: 'chronomat-b01-42',
      },
      type: {
        EN_US: ['Men', 'Titanium', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'Titanio', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '钛金属', '百年灵自制机芯'],
      },
      universe: 'LAND',
      head_reference: 'EB013410/M549',
      size: 42.0,
      size_range: '42-43',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/eb0134101m1e1-on-wrist_0e4785e0.png',
      collections: [
        {
          name: 'Chronomat',
          slug: 'chronomat',
          id: 'Q29sbGVjdGlvbjo3Ng==',
        },
      ],
      collection: 'Chronomat',
      collection_id: 'Q29sbGVjdGlvbjo3Ng==',
      com_trace_story: null,
      case: {
        EN_US: 'Titanium | TITNM',
        ES: 'Titanio | TITNM',
        ZH_HANS: '钛金属 | TITNM',
      },
      dial_color: {
        EN_US: 'Anthracite | V-DIAL-COLOR-5664',
        ES: 'Antracita | V-DIAL-COLOR-5664',
        ZH_HANS: '烟煤色 | V-DIAL-COLOR-5664',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:33:58',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1712138400,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'EB0134101M1E1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Chronomat B01 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Chronomat B01 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '机械计时B01计时腕表42（Chronomat B01 42）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Chronomat',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Chronomat',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Titanium | TITNM',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Titanio | TITNM',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '钛金属 | TITNM',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Anthracite | V-DIAL-COLOR-5664',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Antracita | V-DIAL-COLOR-5664',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '烟煤色 | V-DIAL-COLOR-5664',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Avenger Automatic GMT 44',
      model_en: 'Avenger Automatic GMT 44 (MY2023)',
      case_en: 'Stainless steel',
      dial_color_en: 'Blue',
      type_en: ['Men'],
      com_trace_story_en: null,
      pdp_release_ts: 1698836400,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1698836400,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1698836400,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1698836400,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDIyMw==',
      product_id: 'UHJvZHVjdDo0Mjg3',
      name: {
        EN_US: 'Avenger Automatic GMT 44',
        ES: 'Avenger Automatic GMT 44',
        ZH_HANS: '复仇者双时区自动机械腕表44',
      },
      product_type: 'Watch',
      ecomm_available: false,
      phone_sale_available: true,
      price: 5700.0,
      price_range: '0-5999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/a32320101c1a1-soldier_bee8c4e1_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/a32320101c1a1-soldier_bee8c4e1.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1720617816,
      launch_date: 1698796800,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-A3232010/CB69',
      model: {
        name: {
          EN_US: 'Avenger Automatic GMT 44 (MY23)',
          ES: 'Avenger Automatic GMT 44 (MY23)',
          ZH_HANS:
            '复仇者世界时间自动机械腕表44(MY23)（Avenger Automatic GMT 44 (MY23)）',
        },
        slug: 'avenger-automatic-gmt-44-my2023',
      },
      type: {
        EN_US: ['Men'],
        ES: ['Hombre'],
        ZH_HANS: ['男士'],
      },
      universe: 'AIR',
      head_reference: 'A3232010/CB69',
      size: 44.0,
      size_range: '44-45',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/a32320101c1a1-on-wrist_9640aaa3.png',
      collections: [
        {
          name: 'Avenger',
          slug: 'avenger',
          id: 'Q29sbGVjdGlvbjo2Nw==',
        },
      ],
      collection: 'Avenger',
      collection_id: 'Q29sbGVjdGlvbjo2Nw==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Blue | V-DIAL-COLOR-5714',
        ES: 'Azul | V-DIAL-COLOR-5714',
        ZH_HANS: '蓝色 | V-DIAL-COLOR-5714',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:34:15',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1698836400,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'A32320101C1A1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Avenger Automatic GMT 44',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Avenger Automatic GMT 44',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '复仇者双时区自动机械腕表44',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Avenger',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Avenger',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Blue | V-DIAL-COLOR-5714',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Azul | V-DIAL-COLOR-5714',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '蓝色 | V-DIAL-COLOR-5714',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Navitimer Automatic 36',
      model_en: 'Navitimer Automatic 36',
      case_en: 'Small scale traceable 18K red gold',
      dial_color_en: 'Mother-of-pearl',
      type_en: ['Men', 'Gold', 'Women'],
      com_trace_story_en:
        'Breitling is on a mission to do better by improving the social and environmental impact of our products and ensuring our precious materials have end-to-end traceability. \nYour watch is made using gold from a Swiss Better Gold Association-accredited mine. We’ve traced this gold throughout its entire supply chain: from its extraction in Latin America to the casting of its case in Switzerland. That’s why we call it better gold. \nYour watch also features lab-grown diamonds from accredited producers that have achieved the SCS-007 Sustainability Rated Diamonds standard. The lab-grown diamonds in your watch can be traced from their producers in India and the US, to their final jewel-setting in Switzerland. That’s why we call them better diamonds .\nWith the purchase of this watch, you’re part of a new direction in watchmaking on our mission to do better.',
      pdp_release_ts: 1693994400,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1693994400,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1693994400,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1693994400,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDEwOQ==',
      product_id: 'UHJvZHVjdDo0MTU0',
      name: {
        EN_US: 'Navitimer Automatic 36',
        ES: 'Navitimer Automatic 36',
        ZH_HANS: '航空计时自动机械腕表36（Navitimer Automatic 36）',
      },
      product_type: 'Watch',
      ecomm_available: false,
      phone_sale_available: true,
      price: 33950.0,
      price_range: '12000-inf',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/r17327211a1r1-soldier_9d9dbc90_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/r17327211a1r1-soldier_9d9dbc90.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1720617883,
      launch_date: 1693958400,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-R1732721/A856',
      model: {
        name: {
          EN_US: 'Navitimer Automatic 36',
          ES: 'Navitimer Automatic 36',
          ZH_HANS: '航空计时自动机械腕表36（Navitimer Automatic 36）',
        },
        slug: 'navitimer-automatic-36',
      },
      type: {
        EN_US: ['Men', 'Gold', 'Women'],
        ES: ['Hombre', 'Oro', 'Mujer'],
        ZH_HANS: ['男士', '金质', '女士'],
      },
      universe: 'AIR',
      head_reference: 'R1732721/A856',
      size: 36.0,
      size_range: '36-37',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/r17327211a1r1-on-wrist_e08ccdc5.png',
      collections: [
        {
          name: 'Navitimer',
          slug: 'navitimer',
          id: 'Q29sbGVjdGlvbjo3NA==',
        },
      ],
      collection: 'Navitimer',
      collection_id: 'Q29sbGVjdGlvbjo3NA==',
      com_trace_story: {
        EN_US:
          'Breitling is on a mission to do better by improving the social and environmental impact of our products and ensuring our precious materials have end-to-end traceability. \nYour watch is made using gold from a Swiss Better Gold Association-accredited mine. We’ve traced this gold throughout its entire supply chain: from its extraction in Latin America to the casting of its case in Switzerland. That’s why we call it better gold. \nYour watch also features lab-grown diamonds from accredited producers that have achieved the SCS-007 Sustainability Rated Diamonds standard. The lab-grown diamonds in your watch can be traced from their producers in India and the US, to their final jewel-setting in Switzerland. That’s why we call them better diamonds .\nWith the purchase of this watch, you’re part of a new direction in watchmaking on our mission to do better. | COM_TRACE_STORY_1-R17327211A1R1',
        ES: 'Breitling tiene el lema «mission to do better», y lo aplica mejorando el impacto social y medioambiental de nuestros productos, así como garantizando la trazabilidad de nuestros valiosísimos materiales de principio a fin. \nTu reloj está fabricado con el oro procedente de una mina acreditada por la Swiss Better Gold Association. Hemos trazado el recorrido de este oro a lo largo de toda la cadena de suministro: desde su extracción en Latinoamérica hasta la fundición de la caja en Suiza. Por eso lo llamamos «mejor oro». \nTu reloj también cuenta con diamantes cultivados en laboratorio por productores acreditados que han conseguido la norma SCS-007 Sustainability Rated Diamonds. El recorrido de los diamantes cultivados en laboratorio de tu reloj se puede trazar desde sus productores en la India y EE. UU. hasta su engaste final en Suiza. Por eso los llamamos «mejores diamantes».\nCon la compra de este reloj, formarás parte de un nuevo rumbo de la relojería en nuestra «mission to do better». | COM_TRACE_STORY_1-R17327211A1R1',
        ZH_HANS:
          '百年灵旨在通过改善产品对社会和环境的影响，并确保珍贵材料实现端到端可追溯性，完成优中选优的使命。 \n您所购腕表中的黄金源自瑞士黄金协会认证的金矿。从拉丁美洲矿山开采，直至在瑞士进行表壳铸造，百年灵追溯这些黄金的完整供应链。正因如此，百年灵称之为优中选优黄金。 \n您所购买的腕表还镶嵌实验室培育钻石，钻石生产商已获认证，且已达到SCS-007可持续钻石评级标准。您所购腕表中的实验室培育钻石，可追溯至印度和美国的生产商，直至在瑞士的最终珠宝镶嵌。正因如此，百年灵称之为优中选优钻石。\n购买这款腕表，您将助力我们继续秉承优中选优的使命，探索制表新航道。 | COM_TRACE_STORY_1-R17327211A1R1',
      },
      case: {
        EN_US: 'Small scale traceable 18K red gold | BETTERGOLD',
        ES: 'Oro rojo de 18K con trazabilidad a pequeña escala | BETTERGOLD',
        ZH_HANS: 'Small scale traceable gold（18K红金） | BETTERGOLD',
      },
      dial_color: {
        EN_US: 'Mother-of-pearl | V-DIAL-COLOR-5791',
        ES: 'Madreperla | V-DIAL-COLOR-5791',
        ZH_HANS: '珍珠贝母 | V-DIAL-COLOR-5791',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:33:29',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1693994400,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'R17327211A1R1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Navitimer Automatic 36',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Navitimer Automatic 36',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '航空计时自动机械腕表36（Navitimer Automatic 36）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Navitimer',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Navitimer',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Small scale traceable 18K red gold | BETTERGOLD',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value:
              'Oro rojo de 18K con trazabilidad a pequeña escala | BETTERGOLD',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: 'Small scale traceable gold（18K红金） | BETTERGOLD',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Mother-of-pearl | V-DIAL-COLOR-5791',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Madreperla | V-DIAL-COLOR-5791',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '珍珠贝母 | V-DIAL-COLOR-5791',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Navitimer B01 Chronograph 41',
      model_en: 'Navitimer B01 Chronograph 41 (MY22)',
      case_en: 'Stainless steel (gem-set)',
      dial_color_en: 'Blue',
      type_en: ['Men', 'Women', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1691056800,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1691056800,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1691056800,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1691056800,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDUxNA==',
      product_id: 'UHJvZHVjdDo0NzMz',
      name: {
        EN_US: 'Navitimer B01 Chronograph 41',
        ES: 'Navitimer B01 Chronograph 41',
        ZH_HANS: '航空计时B01计时腕表41（Navitimer B01 Chronograph 41）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 16200.0,
      price_range: '12000-inf',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/ab0139631c1p1-soldier_2c0268ef_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0139631c1p1-soldier_2c0268ef.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1720617843,
      launch_date: 1691020800,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-AB013963/CB60',
      model: {
        name: {
          EN_US: 'Navitimer B01 Chronograph 41 (MY22)',
          ES: 'Navitimer B01 Chronograph 41',
          ZH_HANS: '航空计时B01计时腕表41（Navitimer B01 Chronograph 41）',
        },
        slug: 'navitimer-b01-chronograph-41-my22',
      },
      type: {
        EN_US: ['Men', 'Women', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'Mujer', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '女士', '百年灵自制机芯'],
      },
      universe: 'AIR',
      head_reference: 'AB013963/CB60',
      size: 41.0,
      size_range: '40-41',
      collections: [
        {
          name: 'Navitimer',
          slug: 'navitimer',
          id: 'Q29sbGVjdGlvbjo3NA==',
        },
      ],
      collection: 'Navitimer',
      collection_id: 'Q29sbGVjdGlvbjo3NA==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel (gem-set) | STNSTL_GEM',
        ES: 'Acero inoxidable (engastado) | STNSTL_GEM',
        ZH_HANS: '精钢（镶嵌宝石） | STNSTL_GEM',
      },
      dial_color: {
        EN_US: 'Blue | V-DIAL-COLOR-5714',
        ES: 'Azul | V-DIAL-COLOR-5714',
        ZH_HANS: '蓝色 | V-DIAL-COLOR-5714',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        attrs_without_value: ['image_wrist_url'],
        updated_at_utc: '2025-05-09 19:32:03',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1691056800,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'AB0139631C1P1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Navitimer B01 Chronograph 41',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Navitimer B01 Chronograph 41',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '航空计时B01计时腕表41（Navitimer B01 Chronograph 41）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Navitimer',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Navitimer',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel (gem-set) | STNSTL_GEM',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable (engastado) | STNSTL_GEM',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢（镶嵌宝石） | STNSTL_GEM',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Blue | V-DIAL-COLOR-5714',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Azul | V-DIAL-COLOR-5714',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '蓝色 | V-DIAL-COLOR-5714',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Top Time B01 Deus',
      model_en: 'Top Time (B01)',
      case_en: 'Stainless steel',
      dial_color_en: 'Black',
      type_en: ['Men', 'Women', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1687341600,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1687341600,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1687341600,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1687341600,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6MzIzNA==',
      product_id: 'UHJvZHVjdDozMjQ0',
      name: {
        EN_US: 'Top Time B01 Deus',
        ES: 'Top Time B01 Deus',
        ZH_HANS: 'Top Time系列B01 Deus腕表',
      },
      product_type: 'Watch',
      ecomm_available: false,
      phone_sale_available: true,
      price: 8250.0,
      price_range: '6000-8999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/ab01765a1b1x1-soldier_0835698e_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab01765a1b1x1-soldier_0835698e.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736487,
      launch_date: 1687305600,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-AB01765A/BJ26',
      model: {
        name: {
          EN_US: 'Top Time (B01)',
          ES: 'Top Time (B01)',
          ZH_HANS: 'Top Time B01计时码表（Top Time (B01)）',
        },
        slug: 'top-time-b01',
      },
      type: {
        EN_US: ['Men', 'Women', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'Mujer', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '女士', '百年灵自制机芯'],
      },
      universe: 'LAND',
      head_reference: 'AB01765A/BJ26',
      size: 41.0,
      size_range: '40-41',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab01765a1b1x1-on-wrist_ff1a065d.png',
      collections: [
        {
          name: 'Top Time',
          slug: 'top-time',
          id: 'Q29sbGVjdGlvbjo3OA==',
        },
      ],
      collection: 'Top Time',
      collection_id: 'Q29sbGVjdGlvbjo3OA==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Black | V-DIAL-COLOR-5686',
        ES: 'Negro | V-DIAL-COLOR-5686',
        ZH_HANS: '黑色 | V-DIAL-COLOR-5686',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:24:40',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1687341600,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'AB01765A1B1X1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Top Time B01 Deus',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Top Time B01 Deus',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: 'Top Time系列B01 Deus腕表',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Top Time',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Top Time',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Black | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Negro | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '黑色 | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Top Time B01 Triumph',
      model_en: 'Top Time (B01)',
      case_en: 'Stainless steel',
      dial_color_en: 'Ice blue',
      type_en: ['Men', 'Women', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1687341600,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1687341600,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1687341600,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1687341600,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6MzM1NQ==',
      product_id: 'UHJvZHVjdDozMzc0',
      name: {
        EN_US: 'Top Time B01 Triumph',
        ES: 'Top Time B01 Triumph',
        ZH_HANS: 'Top Time系列B01 Triumph腕表',
      },
      product_type: 'Watch',
      ecomm_available: false,
      phone_sale_available: true,
      price: 8250.0,
      price_range: '6000-8999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/ab01764a1c1x1-soldier_a69e6760_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab01764a1c1x1-soldier_a69e6760.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736484,
      launch_date: 1687305600,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-AB01764A/CB52',
      model: {
        name: {
          EN_US: 'Top Time (B01)',
          ES: 'Top Time (B01)',
          ZH_HANS: 'Top Time B01计时码表（Top Time (B01)）',
        },
        slug: 'top-time-b01',
      },
      type: {
        EN_US: ['Men', 'Women', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'Mujer', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '女士', '百年灵自制机芯'],
      },
      universe: 'LAND',
      head_reference: 'AB01764A/CB52',
      size: 41.0,
      size_range: '40-41',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab01764a1c1x1-on-wrist_de7a635b.png',
      collections: [
        {
          name: 'Top Time',
          slug: 'top-time',
          id: 'Q29sbGVjdGlvbjo3OA==',
        },
      ],
      collection: 'Top Time',
      collection_id: 'Q29sbGVjdGlvbjo3OA==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Ice blue | V-DIAL-COLOR-1111',
        ES: 'Azul hielo | V-DIAL-COLOR-1111',
        ZH_HANS: '冰蓝 | V-DIAL-COLOR-1111',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:25:18',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1687341600,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'AB01764A1C1X1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Top Time B01 Triumph',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Top Time B01 Triumph',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: 'Top Time系列B01 Triumph腕表',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Top Time',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Top Time',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Ice blue | V-DIAL-COLOR-1111',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Azul hielo | V-DIAL-COLOR-1111',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '冰蓝 | V-DIAL-COLOR-1111',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Endurance Pro (Princeton® University Edition)',
      model_en: 'Endurance Pro',
      case_en: 'Breitlight®',
      dial_color_en: 'Black',
      type_en: ['Men', 'Professional'],
      com_trace_story_en: null,
      pdp_release_ts: 1681812000,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1681812000,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1681812000,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1681812000,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDI1NQ==',
      product_id: 'UHJvZHVjdDo0MzE5',
      name: {
        EN_US: 'Endurance Pro 44 Princeton® University Edition',
        ES: 'Endurance Pro 44 Princeton® University Edition',
        ZH_HANS: '专业耐力腕表（Endurance Pro 44）普林斯顿大学版®',
      },
      product_type: 'Watch',
      ecomm_available: false,
      phone_sale_available: true,
      price: 3700.0,
      price_range: '0-5999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/x823104c1b1s1-soldier_e8d83f95_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/x823104c1b1s1-soldier_e8d83f95.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1720617936,
      launch_date: 1681776000,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-X823104C/BJ49',
      model: {
        name: {
          EN_US: 'Endurance Pro',
          ES: 'Endurance Pro',
          ZH_HANS: '专业耐力腕表（Endurance Pro）',
        },
        slug: 'endurance-pro',
      },
      type: {
        EN_US: ['Men', 'Professional'],
        ES: ['Hombre', 'Profesional'],
        ZH_HANS: ['男士', '专业'],
      },
      universe: 'Professional',
      head_reference: 'X823104C/BJ49',
      size: 44.0,
      size_range: '44-45',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/x823104c1b1s1-on-wrist_718e04a8.png',
      collections: [
        {
          name: 'Professional',
          slug: 'professional',
          id: 'Q29sbGVjdGlvbjo3OQ==',
        },
      ],
      collection: 'Professional',
      collection_id: 'Q29sbGVjdGlvbjo3OQ==',
      com_trace_story: null,
      case: {
        EN_US: 'Breitlight® | BREITL',
        ES: 'Breitlight® | BREITL',
        ZH_HANS: 'Breitlight® | BREITL',
      },
      dial_color: {
        EN_US: 'Black | V-DIAL-COLOR-5686',
        ES: 'Negro | V-DIAL-COLOR-5686',
        ZH_HANS: '黑色 | V-DIAL-COLOR-5686',
      },
      marketing_status: ['Country Exclusive'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:32:26',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1681812000,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'X823104C1B1S1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Endurance Pro 44 Princeton® University Edition',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Endurance Pro 44 Princeton® University Edition',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '专业耐力腕表（Endurance Pro 44）普林斯顿大学版®',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Professional',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Professional',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Breitlight® | BREITL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Breitlight® | BREITL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: 'Breitlight® | BREITL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Black | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Negro | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '黑色 | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Endurance Pro United States Naval Academy™',
      model_en: 'Endurance Pro',
      case_en: 'Breitlight®',
      dial_color_en: 'Black',
      type_en: ['Men', 'Professional'],
      com_trace_story_en: null,
      pdp_release_ts: 1681812000,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1681812000,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1681812000,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1681812000,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDI1Ng==',
      product_id: 'UHJvZHVjdDo0MzIw',
      name: {
        EN_US: 'Endurance Pro 44 United States Naval Academy™',
        ES: 'Endurance Pro 44 Academia Naval de los Estados Unidos™',
        ZH_HANS: '专业耐力腕表（Endurance Pro 44）美国海军学院版™',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 3700.0,
      price_range: '0-5999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/x823103c1b1s1-soldier_75ae7a63_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/x823103c1b1s1-soldier_75ae7a63.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1720617935,
      launch_date: 1681776000,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-X823103C/BJ48',
      model: {
        name: {
          EN_US: 'Endurance Pro',
          ES: 'Endurance Pro',
          ZH_HANS: '专业耐力腕表（Endurance Pro）',
        },
        slug: 'endurance-pro',
      },
      type: {
        EN_US: ['Men', 'Professional'],
        ES: ['Hombre', 'Profesional'],
        ZH_HANS: ['男士', '专业'],
      },
      universe: 'Professional',
      head_reference: 'X823103C/BJ48',
      size: 44.0,
      size_range: '44-45',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/x823103c1b1s1-on-wrist_adc87227.png',
      collections: [
        {
          name: 'Professional',
          slug: 'professional',
          id: 'Q29sbGVjdGlvbjo3OQ==',
        },
      ],
      collection: 'Professional',
      collection_id: 'Q29sbGVjdGlvbjo3OQ==',
      com_trace_story: null,
      case: {
        EN_US: 'Breitlight® | BREITL',
        ES: 'Breitlight® | BREITL',
        ZH_HANS: 'Breitlight® | BREITL',
      },
      dial_color: {
        EN_US: 'Black | V-DIAL-COLOR-5686',
        ES: 'Negro | V-DIAL-COLOR-5686',
        ZH_HANS: '黑色 | V-DIAL-COLOR-5686',
      },
      marketing_status: ['Country Exclusive'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:31:26',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1681812000,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'X823103C1B1S1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Endurance Pro 44 United States Naval Academy™',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Endurance Pro 44 Academia Naval de los Estados Unidos™',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '专业耐力腕表（Endurance Pro 44）美国海军学院版™',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Professional',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Professional',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Breitlight® | BREITL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Breitlight® | BREITL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: 'Breitlight® | BREITL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Black | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Negro | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '黑色 | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Endurance Pro The University of Alabama®',
      model_en: 'Endurance Pro',
      case_en: 'Breitlight®',
      dial_color_en: 'Black',
      type_en: ['Men', 'Professional'],
      com_trace_story_en: null,
      pdp_release_ts: 1681812000,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1681812000,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1681812000,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1681812000,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDI1NA==',
      product_id: 'UHJvZHVjdDo0MzE4',
      name: {
        EN_US: 'Endurance Pro 44 The University of Alabama®',
        ES: 'Endurance Pro 44 Universidad de Alabama®',
        ZH_HANS: '专业耐力腕表（Endurance Pro 44）阿拉巴马大学版®',
      },
      product_type: 'Watch',
      ecomm_available: false,
      phone_sale_available: true,
      price: 3700.0,
      price_range: '0-5999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/x823102c1b1s1-soldier_63a1a11f_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/x823102c1b1s1-soldier_63a1a11f.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1720617935,
      launch_date: 1681776000,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-X823102C/BJ47',
      model: {
        name: {
          EN_US: 'Endurance Pro',
          ES: 'Endurance Pro',
          ZH_HANS: '专业耐力腕表（Endurance Pro）',
        },
        slug: 'endurance-pro',
      },
      type: {
        EN_US: ['Men', 'Professional'],
        ES: ['Hombre', 'Profesional'],
        ZH_HANS: ['男士', '专业'],
      },
      universe: 'Professional',
      head_reference: 'X823102C/BJ47',
      size: 44.0,
      size_range: '44-45',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/x823102c1b1s1-on-wrist_6d57fd2b.png',
      collections: [
        {
          name: 'Professional',
          slug: 'professional',
          id: 'Q29sbGVjdGlvbjo3OQ==',
        },
      ],
      collection: 'Professional',
      collection_id: 'Q29sbGVjdGlvbjo3OQ==',
      com_trace_story: null,
      case: {
        EN_US: 'Breitlight® | BREITL',
        ES: 'Breitlight® | BREITL',
        ZH_HANS: 'Breitlight® | BREITL',
      },
      dial_color: {
        EN_US: 'Black | V-DIAL-COLOR-5686',
        ES: 'Negro | V-DIAL-COLOR-5686',
        ZH_HANS: '黑色 | V-DIAL-COLOR-5686',
      },
      marketing_status: ['Country Exclusive'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:29:26',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1681812000,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'X823102C1B1S1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Endurance Pro 44 The University of Alabama®',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Endurance Pro 44 Universidad de Alabama®',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '专业耐力腕表（Endurance Pro 44）阿拉巴马大学版®',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Professional',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Professional',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Breitlight® | BREITL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Breitlight® | BREITL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: 'Breitlight® | BREITL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Black | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Negro | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '黑色 | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Endurance Pro University of Michigan™',
      model_en: 'Endurance Pro',
      case_en: 'Breitlight®',
      dial_color_en: 'Black',
      type_en: ['Men', 'Professional'],
      com_trace_story_en: null,
      pdp_release_ts: 1727042400,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1727042400,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1727042400,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1727042400,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDI1Mw==',
      product_id: 'UHJvZHVjdDo0MzE3',
      name: {
        EN_US: 'Endurance Pro 44 University of Michigan™',
        ES: 'Endurance Pro 44 Universidad de Michigan™',
        ZH_HANS: '专业耐力腕表（Endurance Pro 44）密歇根大学版™',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 3700.0,
      price_range: '0-5999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/x823101c1b1s1-soldier_3642a1a4_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/x823101c1b1s1-soldier_3642a1a4.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1720617934,
      launch_date: 1681776000,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-X823101C/BJ46',
      model: {
        name: {
          EN_US: 'Endurance Pro',
          ES: 'Endurance Pro',
          ZH_HANS: '专业耐力腕表（Endurance Pro）',
        },
        slug: 'endurance-pro',
      },
      type: {
        EN_US: ['Men', 'Professional'],
        ES: ['Hombre', 'Profesional'],
        ZH_HANS: ['男士', '专业'],
      },
      universe: 'Professional',
      head_reference: 'X823101C/BJ46',
      size: 44.0,
      size_range: '44-45',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/x823101c1b1s1-on-wrist_71d70315.png',
      collections: [
        {
          name: 'Professional',
          slug: 'professional',
          id: 'Q29sbGVjdGlvbjo3OQ==',
        },
      ],
      collection: 'Professional',
      collection_id: 'Q29sbGVjdGlvbjo3OQ==',
      com_trace_story: null,
      case: {
        EN_US: 'Breitlight® | BREITL',
        ES: 'Breitlight® | BREITL',
        ZH_HANS: 'Breitlight® | BREITL',
      },
      dial_color: {
        EN_US: 'Black | V-DIAL-COLOR-5686',
        ES: 'Negro | V-DIAL-COLOR-5686',
        ZH_HANS: '黑色 | V-DIAL-COLOR-5686',
      },
      marketing_status: ['Country Exclusive'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:31:18',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1727042400,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'X823101C1B1S1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Endurance Pro 44 University of Michigan™',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Endurance Pro 44 Universidad de Michigan™',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '专业耐力腕表（Endurance Pro 44）密歇根大学版™',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Professional',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Professional',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Breitlight® | BREITL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Breitlight® | BREITL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: 'Breitlight® | BREITL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Black | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Negro | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '黑色 | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Premier B09 Chronograph 40',
      model_en: 'Premier B09 Chronograph 40',
      case_en: 'Stainless steel',
      dial_color_en: 'Silver',
      type_en: ['Men', 'Women', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1681812000,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1681812000,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1681812000,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1681812000,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6MzE5NQ==',
      product_id: 'UHJvZHVjdDozMjAy',
      name: {
        EN_US: 'Premier B09 Chronograph 40',
        ES: 'Premier B09 Chronograph 40',
        ZH_HANS: '璞雅文化B09计时腕表40（Premier B09 Chronograph 40）',
      },
      product_type: 'Watch',
      ecomm_available: false,
      phone_sale_available: true,
      price: 9000.0,
      price_range: '9000-9999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/ab0930371g1p1-soldier_ac1b1f45_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0930371g1p1-soldier_ac1b1f45.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736488,
      launch_date: 1681776000,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-AB093037/G893',
      model: {
        name: {
          EN_US: 'Premier B09 Chronograph 40',
          ES: 'Premier B09 Chronograph 40',
          ZH_HANS: '璞雅文化B09计时腕表40（Premier B09 Chronograph 40）',
        },
        slug: 'premier-b09-chronograph-40',
      },
      type: {
        EN_US: ['Men', 'Women', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'Mujer', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '女士', '百年灵自制机芯'],
      },
      universe: 'LAND',
      head_reference: 'AB093037/G893',
      size: 40.0,
      size_range: '40-41',
      collections: [
        {
          name: 'Premier',
          slug: 'premier',
          id: 'Q29sbGVjdGlvbjo3Mw==',
        },
      ],
      collection: 'Premier',
      collection_id: 'Q29sbGVjdGlvbjo3Mw==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Silver | V-DIAL-COLOR-5843',
        ES: 'Plata | V-DIAL-COLOR-5843',
        ZH_HANS: '银色 | V-DIAL-COLOR-5843',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        attrs_without_value: ['image_wrist_url'],
        updated_at_utc: '2025-05-09 19:29:22',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1681812000,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'AB0930371G1P1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Premier B09 Chronograph 40',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Premier B09 Chronograph 40',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '璞雅文化B09计时腕表40（Premier B09 Chronograph 40）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Premier',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Premier',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Silver | V-DIAL-COLOR-5843',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Plata | V-DIAL-COLOR-5843',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '银色 | V-DIAL-COLOR-5843',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Super Chronomat B01 44',
      model_en: 'Super Chronomat B01 44',
      case_en: 'Stainless steel & 18k red gold',
      dial_color_en: 'Green',
      type_en: ['Men', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1667818800,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1667818800,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1667818800,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1667818800,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6MzgwMg==',
      product_id: 'UHJvZHVjdDozODM1',
      name: {
        EN_US: 'Super Chronomat B01 44',
        ES: 'Super Chronomat B01 44',
        ZH_HANS: '超级机械计时B01腕表44（Super Chronomat B01 44）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 11850.0,
      price_range: '10000-11999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/ub0136251l1s1-soldier_59c9e404_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ub0136251l1s1-soldier_59c9e404.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736595,
      launch_date: 1667779200,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-UB013625/L580',
      model: {
        name: {
          EN_US: 'Super Chronomat B01 44',
          ES: 'Super Chronomat B01 44',
          ZH_HANS: '超级机械计时B01腕表44（Super Chronomat B01 44）',
        },
        slug: 'super-chronomat-b01-44',
      },
      type: {
        EN_US: ['Men', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '百年灵自制机芯'],
      },
      universe: 'LAND',
      head_reference: 'UB013625/L580',
      size: 44.0,
      size_range: '44-45',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ub0136251l1s1-on-wrist_faa8ec8e.png',
      collections: [
        {
          name: 'Chronomat',
          slug: 'chronomat',
          id: 'Q29sbGVjdGlvbjo3Ng==',
        },
      ],
      collection: 'Chronomat',
      collection_id: 'Q29sbGVjdGlvbjo3Ng==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel & 18k red gold | STNSTL_18KREG',
        ES: 'Acero inoxidable y oro rojo de 18K | STNSTL_18KREG',
        ZH_HANS: '精钢和18K红金 | STNSTL_18KREG',
      },
      dial_color: {
        EN_US: 'Green | V-DIAL-COLOR-5765',
        ES: 'Verde | V-DIAL-COLOR-5765',
        ZH_HANS: '绿色 | V-DIAL-COLOR-5765',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:24:53',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1667818800,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'UB0136251L1S1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Super Chronomat B01 44',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Super Chronomat B01 44',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '超级机械计时B01腕表44（Super Chronomat B01 44）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Chronomat',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Chronomat',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel & 18k red gold | STNSTL_18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable y oro rojo de 18K | STNSTL_18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢和18K红金 | STNSTL_18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Green | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Verde | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '绿色 | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Super Chronomat Automatic 38',
      model_en: 'Super Chronomat Automatic 38',
      case_en: 'Stainless steel & 18k red gold',
      dial_color_en: 'Green',
      type_en: ['Men', 'Women'],
      com_trace_story_en:
        'Your watch represents a first for Breitling. We’re on a mission to do better by improving the social and environmental impact of our products and ensuring our precious materials have end-to-end traceability. That journey began with the proof-of-concept Super Chronomat Automatic 38 Origins, whose gold is traceable to a single mine and whose lab-grown diamonds are traceable to a single grower.  \nBy 2025, to scale this concept across Breitling’s entire collection, we will work with a small pool of these carefully selected suppliers. With your purchase of the very first Super Chronomat Origins release derived from individual sources, you are the owner of something truly unique.  \n\nSuper Chronomat Origins is made using gold from a Swiss Better Gold Association-accredited mine in Colombia. We’ve traced this gold throughout its entire supply chain: from its artisanal mine to the casting of its case in Switzerland. That’s why we call it better gold.  \nYour watch also features lab-grown diamonds from an accredited producer that has achieved the SCS-007 Sustainability Rated Diamonds standard. The lab-grown diamonds in your watch can be traced from a single-source lab in India to their final jewel-setting in Switzerland. That’s why we call them better diamonds.  \n\nOur mission to do better started here. And now you’re a part of it.',
      pdp_release_ts: 1666260000,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1666260000,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1666260000,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1666260000,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDM1OA==',
      product_id: 'UHJvZHVjdDo0NTE2',
      name: {
        EN_US: 'Super Chronomat Automatic 38',
        ES: 'Super Chronomat Automatic 38',
        ZH_HANS: '超级机械计时自动机械腕表38（Super Chronomat Automatic 38）',
      },
      product_type: 'Watch',
      ecomm_available: false,
      phone_sale_available: true,
      price: 14600.0,
      price_range: '12000-inf',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/u17356531l1u1-soldier_4e898b6d_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/u17356531l1u1-soldier_4e898b6d.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1720617932,
      launch_date: 1666224000,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-U1735653/L582',
      model: {
        name: {
          EN_US: 'Super Chronomat Automatic 38',
          ES: 'Super Chronomat Automatic 38',
          ZH_HANS: '超级机械计时自动机械腕表38（Super Chronomat Automatic 38）',
        },
        slug: 'super-chronomat-automatic-38',
      },
      type: {
        EN_US: ['Men', 'Women'],
        ES: ['Hombre', 'Mujer'],
        ZH_HANS: ['男士', '女士'],
      },
      universe: 'LAND',
      head_reference: 'U1735653/L582',
      size: 38.0,
      size_range: '38-39',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/u17356531l1u1-on-wrist_7272edf8.png',
      collections: [
        {
          name: 'Chronomat',
          slug: 'chronomat',
          id: 'Q29sbGVjdGlvbjo3Ng==',
        },
      ],
      collection: 'Chronomat',
      collection_id: 'Q29sbGVjdGlvbjo3Ng==',
      com_trace_story: {
        EN_US:
          'Your watch represents a first for Breitling. We’re on a mission to do better by improving the social and environmental impact of our products and ensuring our precious materials have end-to-end traceability. That journey began with the proof-of-concept Super Chronomat Automatic 38 Origins, whose gold is traceable to a single mine and whose lab-grown diamonds are traceable to a single grower.  \nBy 2025, to scale this concept across Breitling’s entire collection, we will work with a small pool of these carefully selected suppliers. With your purchase of the very first Super Chronomat Origins release derived from individual sources, you are the owner of something truly unique.  \n\nSuper Chronomat Origins is made using gold from a Swiss Better Gold Association-accredited mine in Colombia. We’ve traced this gold throughout its entire supply chain: from its artisanal mine to the casting of its case in Switzerland. That’s why we call it better gold.  \nYour watch also features lab-grown diamonds from an accredited producer that has achieved the SCS-007 Sustainability Rated Diamonds standard. The lab-grown diamonds in your watch can be traced from a single-source lab in India to their final jewel-setting in Switzerland. That’s why we call them better diamonds.  \n\nOur mission to do better started here. And now you’re a part of it. | COM_TRACE_STORY_1-U17356531L1U1',
        ES: 'Tu reloj representa una primicia para Breitling. Nuestra misión es mejorar el impacto social y medioambiental de nuestros productos, así como garantizar la trazabilidad de nuestros materiales preciosos de principio a fin. Este viaje comenzó sometiendo a prueba el concepto del Super Chronomat Automatic 38 Origins, cuyo oro es rastreable hasta una única mina y sus diamantes cultivados en laboratorio lo son hasta un único productor.  \nEn 2025, para ampliar este concepto a toda la colección de Breitling, trabajaremos con un pequeño grupo de estos proveedores cuidadosamente seleccionados. Con la compra de uno de los primeros Super Chronomat Origins, obtenido a partir de fuentes individuales, te conviertes en el propietario de algo verdaderamente único.  \n\nEl Super Chronomat Origins se fabrica con oro procedente de una mina en Colombia acreditada por la Swiss Better Gold Association. Hemos rastreado este oro a lo largo de toda la cadena de suministro: desde la mina artesanal hasta la fundición de la caja en Suiza. Es por lo que lo llamamos «mejor oro».  \nTu reloj también cuenta con diamantes cultivados en laboratorio de un productor acreditado que ha conseguido el estándar SCS-007 Sustainability Rated Diamond. Los diamantes cultivados en laboratorio de tu reloj se pueden rastrear desde su productor único en la India hasta su engaste final en Suiza. Es por lo que los llamamos «mejores diamantes».  \n\nNuestra misión de mejorar empezó aquí. Y ahora tú también formas parte de ella. | COM_TRACE_STORY_1-U17356531L1U1',
        ZH_HANS:
          '您的腕表尽显百年灵的首创精神。百年灵旨在通过改善产品对社会和环境的影响，并确保珍贵材料实现端到端可追溯性，完成优中选优使命。概念验证阶段的超级机械计时自动机械腕表38元年版开启了这一使命之旅，其所用黄金可追溯至单座矿山，而实验室合成钻石可追溯到具体培育者。  \n到2025年，百年灵在精心挑选之后，选择其中少数供应商合作，以在百年灵全系列中推广这一概念。数出有源的首款超级机械计时腕表元年版（Super Chronomat Origins），一旦购买，即拥有了真正的独家珍品。  \n\n超级机械计时腕表元年版所用黄金源自瑞士黄金协会认证的哥伦比亚金矿。从手工开采矿山到在瑞士进行表壳铸造，百年灵追溯这些黄金的完整供应链。正因如此，百年灵称之为优中选优黄金。  \n您所购买的腕表还镶嵌实验室合成钻石，钻石生产商已获认证，且已达到SCS-007可持续钻石评级标准。您所购腕表中的实验室合成钻石，可追溯至印度的单一来源实验室，直至最后在瑞士的最终珠宝镶嵌。正因如此，百年灵称之为优中选优钻石。  \n\n百年灵优中选优的使命自此开始。现在，您也是其中一员。 | COM_TRACE_STORY_1-U17356531L1U1',
      },
      case: {
        EN_US: 'Stainless steel & 18k red gold | STNSTL_18KREG',
        ES: 'Acero inoxidable y oro rojo de 18K | STNSTL_18KREG',
        ZH_HANS: '精钢和18K红金 | STNSTL_18KREG',
      },
      dial_color: {
        EN_US: 'Green | V-DIAL-COLOR-5765',
        ES: 'Verde | V-DIAL-COLOR-5765',
        ZH_HANS: '绿色 | V-DIAL-COLOR-5765',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:25:31',
      },
      widget_is_top_range: true,
      widget_stock_in_wholesaler_ids: [
        'US228516',
        'US102854',
        'US229999',
        'US231131',
        'US102435',
        'US221145',
        'US102977',
        'US102572',
        'US103013',
        'US102367',
        'US102815',
        'US102522',
        'US102515',
        'US102440',
        'US102758',
        'US207515',
        'US102517',
        'US102422',
        'US102477',
        'US102260',
        'US103016',
        'US103039',
        'US103014',
        'US102397',
        'US102306',
        'US102355',
        'US221448',
        'US102288',
        'US102746',
        'US102351',
        'US102875',
        'US102818',
        'US102310',
        'US222013',
        'US102715',
        'US102447',
        'US102718',
        'US102734',
        'US224448',
        'US102379',
        'US102465',
        'US102725',
        'US102399',
        'US102652',
        'US102821',
        'US102717',
        'US102347',
        'US102831',
        'US102366',
        'US102840',
        'US102805',
        'US220584',
        'US103008',
        'US102604',
        'US102764',
        'US102291',
        'US102709',
        'US102532',
        'US102329',
        'US102794',
        'US102368',
        'US102740',
        'US102722',
        'US102468',
        'US102453',
        'US102410',
        'US207516',
        'US102297',
        'US102516',
        'US102553',
        'US102503',
        'US102989',
        'US102421',
        'US102327',
        'US102506',
        'US102414',
        'US103034',
        'US102253',
        'US102978',
        'US102787',
        'US224611',
        'US102314',
        'US102897',
        'US102728',
        'US102538',
        'US231542',
        'US231491',
        'US231826',
        'US230389',
        'US219712',
        'US103023',
        'US102531',
        'US102562',
        'US102889',
        'US102423',
        'US207953',
      ],
      widget_release_ts: 1666260000,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'U17356531L1U1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Super Chronomat Automatic 38',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Super Chronomat Automatic 38',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '超级机械计时自动机械腕表38（Super Chronomat Automatic 38）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Chronomat',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Chronomat',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel & 18k red gold | STNSTL_18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable y oro rojo de 18K | STNSTL_18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢和18K红金 | STNSTL_18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Green | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Verde | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '绿色 | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Super Chronomat Automatic 38 Origins',
      model_en: 'Super Chronomat Automatic 38',
      case_en: 'Small scale traceable 18K red gold',
      dial_color_en: 'Cream',
      type_en: ['Men', 'Gold', 'Women'],
      com_trace_story_en:
        'Breitling is on a mission to do better by improving the social and environmental impact of our products and ensuring our precious materials have end-to-end traceability. \nYour watch is made using gold from a Swiss Better Gold Association-accredited mine. We’ve traced this gold throughout its entire supply chain: from its extraction in Latin America to the casting of its case in Switzerland. That’s why we call it better gold. \nYour watch also features lab-grown diamonds from accredited producers that have achieved the SCS-007 Sustainability Rated Diamonds standard. The lab-grown diamonds in your watch can be traced from their producers in India and the US, to their final jewel-setting in Switzerland. That’s why we call them better diamonds .\nWith the purchase of this watch, you’re part of a new direction in watchmaking on our mission to do better.',
      pdp_release_ts: 1666260000,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1666260000,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1666260000,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1666260000,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDExMQ==',
      product_id: 'UHJvZHVjdDo0MTU3',
      name: {
        EN_US: 'Super Chronomat Automatic 38 Origins',
        ES: 'Super Chronomat Automatic 38 Origins',
        ZH_HANS:
          '超级机械计时自动机械腕表38溯源版（Super Chronomat Automatic 38 Origins）',
      },
      product_type: 'Watch',
      ecomm_available: false,
      phone_sale_available: true,
      price: 21700.0,
      price_range: '12000-inf',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/r17356531g1s1-soldier_c4d8372e_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/r17356531g1s1-soldier_c4d8372e.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736562,
      launch_date: 1666224000,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-R1735653/G890',
      model: {
        name: {
          EN_US: 'Super Chronomat Automatic 38',
          ES: 'Super Chronomat Automatic 38',
          ZH_HANS: '超级机械计时自动机械腕表38（Super Chronomat Automatic 38）',
        },
        slug: 'super-chronomat-automatic-38',
      },
      type: {
        EN_US: ['Men', 'Gold', 'Women'],
        ES: ['Hombre', 'Oro', 'Mujer'],
        ZH_HANS: ['男士', '金质', '女士'],
      },
      universe: 'LAND',
      head_reference: 'R1735653/G890',
      size: 38.0,
      size_range: '38-39',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/r17356531g1s1-on-wrist_edba4a3f.png',
      collections: [
        {
          name: 'Chronomat',
          slug: 'chronomat',
          id: 'Q29sbGVjdGlvbjo3Ng==',
        },
      ],
      collection: 'Chronomat',
      collection_id: 'Q29sbGVjdGlvbjo3Ng==',
      com_trace_story: {
        EN_US:
          'Breitling is on a mission to do better by improving the social and environmental impact of our products and ensuring our precious materials have end-to-end traceability. \nYour watch is made using gold from a Swiss Better Gold Association-accredited mine. We’ve traced this gold throughout its entire supply chain: from its extraction in Latin America to the casting of its case in Switzerland. That’s why we call it better gold. \nYour watch also features lab-grown diamonds from accredited producers that have achieved the SCS-007 Sustainability Rated Diamonds standard. The lab-grown diamonds in your watch can be traced from their producers in India and the US, to their final jewel-setting in Switzerland. That’s why we call them better diamonds .\nWith the purchase of this watch, you’re part of a new direction in watchmaking on our mission to do better. | COM_TRACE_STORY_1-R17356531G1S1',
        ES: 'Breitling tiene el lema «mission to do better», y lo aplica mejorando el impacto social y medioambiental de nuestros productos, así como garantizando la trazabilidad de nuestros valiosísimos materiales de principio a fin. \nTu reloj está fabricado con el oro procedente de una mina acreditada por la Swiss Better Gold Association. Hemos trazado el recorrido de este oro a lo largo de toda la cadena de suministro: desde su extracción en Latinoamérica hasta la fundición de la caja en Suiza. Por eso lo llamamos «mejor oro». \nTu reloj también cuenta con diamantes cultivados en laboratorio por productores acreditados que han conseguido la norma SCS-007 Sustainability Rated Diamonds. El recorrido de los diamantes cultivados en laboratorio de tu reloj se puede trazar desde sus productores en la India y EE. UU. hasta su engaste final en Suiza. Por eso los llamamos «mejores diamantes».\nCon la compra de este reloj, formarás parte de un nuevo rumbo de la relojería en nuestra «mission to do better». | COM_TRACE_STORY_1-R17356531G1S1',
        ZH_HANS:
          '百年灵旨在通过改善产品对社会和环境的影响，并确保珍贵材料实现端到端可追溯性，完成优中选优的使命。 \n您所购腕表中的黄金源自瑞士黄金协会认证的金矿。从拉丁美洲矿山开采，直至在瑞士进行表壳铸造，百年灵追溯这些黄金的完整供应链。正因如此，百年灵称之为优中选优黄金。 \n您所购买的腕表还镶嵌实验室培育钻石，钻石生产商已获认证，且已达到SCS-007可持续钻石评级标准。您所购腕表中的实验室培育钻石，可追溯至印度和美国的生产商，直至在瑞士的最终珠宝镶嵌。正因如此，百年灵称之为优中选优钻石。\n购买这款腕表，您将助力我们继续秉承优中选优的使命，探索制表新航道。 | COM_TRACE_STORY_1-R17356531G1S1',
      },
      case: {
        EN_US: 'Small scale traceable 18K red gold | BETTERGOLD',
        ES: 'Oro rojo de 18K con trazabilidad a pequeña escala | BETTERGOLD',
        ZH_HANS: 'Small scale traceable gold（18K红金） | BETTERGOLD',
      },
      dial_color: {
        EN_US: 'Cream | V-DIAL-COLOR-5842',
        ES: 'Crema | V-DIAL-COLOR-5842',
        ZH_HANS: '奶油色 | V-DIAL-COLOR-5842',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:26:30',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1666260000,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'R17356531G1S1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Super Chronomat Automatic 38 Origins',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Super Chronomat Automatic 38 Origins',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value:
              '超级机械计时自动机械腕表38溯源版（Super Chronomat Automatic 38 Origins）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Chronomat',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Chronomat',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Small scale traceable 18K red gold | BETTERGOLD',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value:
              'Oro rojo de 18K con trazabilidad a pequeña escala | BETTERGOLD',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: 'Small scale traceable gold（18K红金） | BETTERGOLD',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Cream | V-DIAL-COLOR-5842',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Crema | V-DIAL-COLOR-5842',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '奶油色 | V-DIAL-COLOR-5842',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Chronomat Automatic 36',
      model_en: 'Chronomat Automatic 36',
      case_en: 'Stainless steel & 18k red gold',
      dial_color_en: 'Mother-of-pearl',
      type_en: ['Women'],
      com_trace_story_en: null,
      pdp_release_ts: 1666000800,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1666000800,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1666000800,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1666000800,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDE5Mg==',
      product_id: 'UHJvZHVjdDo0MjQ4',
      name: {
        EN_US: 'Chronomat Automatic 36',
        ES: 'Chronomat Automatic 36',
        ZH_HANS: '机械计时自动腕表36（Chronomat Automatic 36）',
      },
      product_type: 'Watch',
      ecomm_available: false,
      phone_sale_available: true,
      price: 9950.0,
      price_range: '9000-9999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/u10380101a2u1-soldier_31f0d2cb_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/u10380101a2u1-soldier_31f0d2cb.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736560,
      launch_date: 1665964800,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-U1038010/A843',
      model: {
        name: {
          EN_US: 'Chronomat Automatic 36',
          ES: 'Chronomat Automatic 36',
          ZH_HANS: '机械计时自动腕表36（Chronomat Automatic 36）',
        },
        slug: 'chronomat-automatic-36',
      },
      type: {
        EN_US: ['Women'],
        ES: ['Mujer'],
        ZH_HANS: ['女士'],
      },
      universe: 'LAND',
      head_reference: 'U1038010/A843',
      size: 36.0,
      size_range: '36-37',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/u10380101a2u1-on-wrist_e8ba8f96.png',
      collections: [
        {
          name: 'Chronomat',
          slug: 'chronomat',
          id: 'Q29sbGVjdGlvbjo3Ng==',
        },
      ],
      collection: 'Chronomat',
      collection_id: 'Q29sbGVjdGlvbjo3Ng==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel & 18k red gold | STNSTL_18KREG',
        ES: 'Acero inoxidable y oro rojo de 18K | STNSTL_18KREG',
        ZH_HANS: '精钢和18K红金 | STNSTL_18KREG',
      },
      dial_color: {
        EN_US: 'Mother-of-pearl | V-DIAL-COLOR-5791',
        ES: 'Madreperla | V-DIAL-COLOR-5791',
        ZH_HANS: '珍珠贝母 | V-DIAL-COLOR-5791',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:25:46',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1666000800,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'U10380101A2U1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Chronomat Automatic 36',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Chronomat Automatic 36',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '机械计时自动腕表36（Chronomat Automatic 36）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Chronomat',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Chronomat',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel & 18k red gold | STNSTL_18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable y oro rojo de 18K | STNSTL_18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢和18K红金 | STNSTL_18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Mother-of-pearl | V-DIAL-COLOR-5791',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Madreperla | V-DIAL-COLOR-5791',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '珍珠贝母 | V-DIAL-COLOR-5791',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Superocean Heritage B20 Automatic 46',
      model_en: 'Superocean Heritage B20 Automatic 46',
      case_en: 'Stainless steel',
      dial_color_en: 'Green',
      type_en: ['Men', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1664445600,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1664445600,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1664445600,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1664445600,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6MzU5MA==',
      product_id: 'UHJvZHVjdDozNjE0',
      name: {
        EN_US: 'Superocean Heritage B20 Automatic 46',
        ES: 'Superocean Heritage B20 Automatic 46',
        ZH_HANS:
          '超级海洋文化系列B20自动机械腕表46（Superocean Heritage B20 Automatic 46）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 5500.0,
      price_range: '0-5999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/ab2020121l1s1-soldier_b9780dcf_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab2020121l1s1-soldier_b9780dcf.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736477,
      launch_date: 1664409600,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-AB202012/L574',
      model: {
        name: {
          EN_US: 'Superocean Heritage B20 Automatic 46',
          ES: 'Superocean Heritage B20 Automatic 46',
          ZH_HANS:
            '超级海洋文化系列B20自动机械腕表46（Superocean Heritage B20 Automatic 46）',
        },
        slug: 'superocean-heritage-b20-automatic-46',
      },
      type: {
        EN_US: ['Men', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '百年灵自制机芯'],
      },
      universe: 'SEA',
      head_reference: 'AB202012/L574',
      size: 46.0,
      size_range: '46-47',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab2020121l1s1-on-wrist_29d649a2.png',
      collections: [
        {
          name: 'Superocean Heritage',
          slug: 'superocean-heritage',
          id: 'Q29sbGVjdGlvbjo3MA==',
        },
      ],
      collection: 'Superocean Heritage',
      collection_id: 'Q29sbGVjdGlvbjo3MA==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Green | V-DIAL-COLOR-5765',
        ES: 'Verde | V-DIAL-COLOR-5765',
        ZH_HANS: '绿色 | V-DIAL-COLOR-5765',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:25:20',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1664445600,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'AB2020121L1S1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Superocean Heritage B20 Automatic 46',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Superocean Heritage B20 Automatic 46',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value:
              '超级海洋文化系列B20自动机械腕表46（Superocean Heritage B20 Automatic 46）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Superocean Heritage',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Superocean Heritage',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Green | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Verde | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '绿色 | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Superocean Automatic 42',
      model_en: 'Superocean Automatic 42 (MY22)',
      case_en: 'Stainless steel & 18k red gold',
      dial_color_en: 'Black',
      type_en: ['Men', 'Women'],
      com_trace_story_en: null,
      pdp_release_ts: 1656583200,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1656583200,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1656583200,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1656583200,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6MzUzMw==',
      product_id: 'UHJvZHVjdDozNTU2',
      name: {
        EN_US: 'Superocean Automatic 42',
        ES: 'Superocean Automatic 42',
        ZH_HANS: '超级海洋自动机械腕表42（Superocean Automatic 42）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 7350.0,
      price_range: '6000-8999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/u17375211b1s1-soldier_27ae6daf_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/u17375211b1s1-soldier_27ae6daf.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736560,
      launch_date: 1656547200,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-U1737521/BI71',
      model: {
        name: {
          EN_US: 'Superocean Automatic 42 (MY22)',
          ES: 'Superocean Automatic 42 (MY22)',
          ZH_HANS: '超级海洋自动机械腕表42（Superocean Automatic 42)',
        },
        slug: 'superocean-automatic-42-my22',
      },
      type: {
        EN_US: ['Men', 'Women'],
        ES: ['Hombre', 'Mujer'],
        ZH_HANS: ['男士', '女士'],
      },
      universe: 'SEA',
      head_reference: 'U1737521/BI71',
      size: 42.0,
      size_range: '42-43',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/u17375211b1s1-on-wrist_f384705c.png',
      collections: [
        {
          name: 'Superocean',
          slug: 'superocean',
          id: 'Q29sbGVjdGlvbjo3NQ==',
        },
      ],
      collection: 'Superocean',
      collection_id: 'Q29sbGVjdGlvbjo3NQ==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel & 18k red gold | STNSTL_18KREG',
        ES: 'Acero inoxidable y oro rojo de 18K | STNSTL_18KREG',
        ZH_HANS: '精钢和18K红金 | STNSTL_18KREG',
      },
      dial_color: {
        EN_US: 'Black | V-DIAL-COLOR-5686',
        ES: 'Negro | V-DIAL-COLOR-5686',
        ZH_HANS: '黑色 | V-DIAL-COLOR-5686',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:25:09',
      },
      widget_is_top_range: true,
      widget_stock_in_wholesaler_ids: [
        'US228516',
        'US102854',
        'US229999',
        'US231131',
        'US102435',
        'US221145',
        'US102977',
        'US102572',
        'US103013',
        'US102367',
        'US102815',
        'US102522',
        'US102515',
        'US102440',
        'US102758',
        'US207515',
        'US102517',
        'US102422',
        'US102477',
        'US102260',
        'US103016',
        'US103039',
        'US103014',
        'US102397',
        'US102306',
        'US102355',
        'US221448',
        'US102288',
        'US102746',
        'US102351',
        'US102875',
        'US102818',
        'US102310',
        'US222013',
        'US102715',
        'US102447',
        'US102718',
        'US102734',
        'US224448',
        'US102379',
        'US102465',
        'US102725',
        'US102399',
        'US102652',
        'US102821',
        'US102717',
        'US102347',
        'US102831',
        'US102366',
        'US102840',
        'US102805',
        'US220584',
        'US103008',
        'US102604',
        'US102764',
        'US102291',
        'US102709',
        'US102532',
        'US102329',
        'US102794',
        'US102368',
        'US102740',
        'US102722',
        'US102468',
        'US102453',
        'US102410',
        'US207516',
        'US102297',
        'US102516',
        'US102553',
        'US102503',
        'US102989',
        'US102421',
        'US102327',
        'US102506',
        'US102414',
        'US103034',
        'US102253',
        'US102978',
        'US102787',
        'US224611',
        'US102314',
        'US102897',
        'US102728',
        'US102538',
        'US231542',
        'US231491',
        'US231826',
        'US230389',
        'US219712',
        'US103023',
        'US102531',
        'US102562',
        'US102889',
        'US102423',
        'US207953',
      ],
      widget_release_ts: 1656583200,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'U17375211B1S1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Superocean Automatic 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Superocean Automatic 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '超级海洋自动机械腕表42（Superocean Automatic 42）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Superocean',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Superocean',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel & 18k red gold | STNSTL_18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable y oro rojo de 18K | STNSTL_18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢和18K红金 | STNSTL_18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Black | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Negro | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '黑色 | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Superocean Automatic 44',
      model_en: 'Superocean Automatic 44 (MY22)',
      case_en: 'Bronze',
      dial_color_en: 'Brown',
      type_en: ['Men'],
      com_trace_story_en: null,
      pdp_release_ts: 1656583200,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1656583200,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1656583200,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1656583200,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6MzY3Nw==',
      product_id: 'UHJvZHVjdDozNzAz',
      name: {
        EN_US: 'Superocean Automatic 44',
        ES: 'Superocean Automatic 44',
        ZH_HANS: '超级海洋自动机械腕表44（Superocean Automatic 44）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 6150.0,
      price_range: '6000-8999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/n17376201q1s1-soldier_56e06273_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/n17376201q1s1-soldier_56e06273.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736523,
      launch_date: 1656547200,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-N1737620/Q633',
      model: {
        name: {
          EN_US: 'Superocean Automatic 44 (MY22)',
          ES: 'Superocean Automatic 44 (MY22)',
          ZH_HANS: '超级海洋自动机械腕表44（Superocean Automatic 44）',
        },
        slug: 'superocean-automatic-44-my22',
      },
      type: {
        EN_US: ['Men'],
        ES: ['Hombre'],
        ZH_HANS: ['男士'],
      },
      universe: 'SEA',
      head_reference: 'N1737620/Q633',
      size: 44.0,
      size_range: '44-45',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/n17376201q1s1-on-wrist_68866e9a.png',
      collections: [
        {
          name: 'Superocean',
          slug: 'superocean',
          id: 'Q29sbGVjdGlvbjo3NQ==',
        },
      ],
      collection: 'Superocean',
      collection_id: 'Q29sbGVjdGlvbjo3NQ==',
      com_trace_story: null,
      case: {
        EN_US: 'Bronze | BRNZ',
        ES: 'Bronce | BRNZ',
        ZH_HANS: '青铜 | BRNZ',
      },
      dial_color: {
        EN_US: 'Brown | V-DIAL-COLOR-5723',
        ES: 'Marrón | V-DIAL-COLOR-5723',
        ZH_HANS: '棕色 | V-DIAL-COLOR-5723',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:24:52',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1656583200,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'N17376201Q1S1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Superocean Automatic 44',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Superocean Automatic 44',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '超级海洋自动机械腕表44（Superocean Automatic 44）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Superocean',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Superocean',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Bronze | BRNZ',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Bronce | BRNZ',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '青铜 | BRNZ',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Brown | V-DIAL-COLOR-5723',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Marrón | V-DIAL-COLOR-5723',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '棕色 | V-DIAL-COLOR-5723',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Superocean Automatic 42',
      model_en: 'Superocean Automatic 42 (MY22)',
      case_en: 'Bronze',
      dial_color_en: 'Green',
      type_en: ['Men', 'Women'],
      com_trace_story_en: null,
      pdp_release_ts: 1656583200,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1656583200,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1656583200,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1656583200,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6MzUwMQ==',
      product_id: 'UHJvZHVjdDozNTIz',
      name: {
        EN_US: 'Superocean Automatic 42',
        ES: 'Superocean Automatic 42',
        ZH_HANS: '超级海洋自动机械腕表42（Superocean Automatic 42）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 6050.0,
      price_range: '6000-8999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/n17375201l1s1-soldier_f9c28606_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/n17375201l1s1-soldier_f9c28606.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736523,
      launch_date: 1656547200,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-N1737520/L578',
      model: {
        name: {
          EN_US: 'Superocean Automatic 42 (MY22)',
          ES: 'Superocean Automatic 42 (MY22)',
          ZH_HANS: '超级海洋自动机械腕表42（Superocean Automatic 42)',
        },
        slug: 'superocean-automatic-42-my22',
      },
      type: {
        EN_US: ['Men', 'Women'],
        ES: ['Hombre', 'Mujer'],
        ZH_HANS: ['男士', '女士'],
      },
      universe: 'SEA',
      head_reference: 'N1737520/L578',
      size: 42.0,
      size_range: '42-43',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/n17375201l1s1-on-wrist_9dc63ce8.png',
      collections: [
        {
          name: 'Superocean',
          slug: 'superocean',
          id: 'Q29sbGVjdGlvbjo3NQ==',
        },
      ],
      collection: 'Superocean',
      collection_id: 'Q29sbGVjdGlvbjo3NQ==',
      com_trace_story: null,
      case: {
        EN_US: 'Bronze | BRNZ',
        ES: 'Bronce | BRNZ',
        ZH_HANS: '青铜 | BRNZ',
      },
      dial_color: {
        EN_US: 'Green | V-DIAL-COLOR-5765',
        ES: 'Verde | V-DIAL-COLOR-5765',
        ZH_HANS: '绿色 | V-DIAL-COLOR-5765',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:25:15',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1656583200,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'N17375201L1S1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Superocean Automatic 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Superocean Automatic 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '超级海洋自动机械腕表42（Superocean Automatic 42）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Superocean',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Superocean',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Bronze | BRNZ',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Bronce | BRNZ',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '青铜 | BRNZ',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Green | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Verde | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '绿色 | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Superocean Automatic 46',
      model_en: 'Superocean Automatic 46 (MY22)',
      case_en: 'Stainless steel',
      dial_color_en: 'Blue',
      type_en: ['Men'],
      com_trace_story_en: null,
      pdp_release_ts: 1656583200,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1656583200,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1656583200,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1656583200,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDQ1Mg==',
      product_id: 'UHJvZHVjdDo0Njcx',
      name: {
        EN_US: 'Superocean Automatic 46',
        ES: 'Superocean Automatic 46',
        ZH_HANS: '超级海洋自动机械腕表46（Superocean Automatic 46）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 5300.0,
      price_range: '0-5999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/a17378e71c1s1-soldier_024538d5_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/a17378e71c1s1-soldier_024538d5.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1720617804,
      launch_date: 1656547200,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-A17378E7/CB30',
      model: {
        name: {
          EN_US: 'Superocean Automatic 46 (MY22)',
          ES: 'Superocean Automatic 46 (MY22)',
          ZH_HANS: '超级海洋自动机械腕表46（Superocean Automatic 46）',
        },
        slug: 'superocean-automatic-46-my22',
      },
      type: {
        EN_US: ['Men'],
        ES: ['Hombre'],
        ZH_HANS: ['男士'],
      },
      universe: 'SEA',
      head_reference: 'A17378E7/CB30',
      size: 46.0,
      size_range: '46-47',
      collections: [
        {
          name: 'Superocean',
          slug: 'superocean',
          id: 'Q29sbGVjdGlvbjo3NQ==',
        },
      ],
      collection: 'Superocean',
      collection_id: 'Q29sbGVjdGlvbjo3NQ==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Blue | V-DIAL-COLOR-5714',
        ES: 'Azul | V-DIAL-COLOR-5714',
        ZH_HANS: '蓝色 | V-DIAL-COLOR-5714',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        attrs_without_value: ['image_wrist_url'],
        updated_at_utc: '2025-05-09 19:27:05',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1656583200,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'A17378E71C1S1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Superocean Automatic 46',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Superocean Automatic 46',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '超级海洋自动机械腕表46（Superocean Automatic 46）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Superocean',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Superocean',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Blue | V-DIAL-COLOR-5714',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Azul | V-DIAL-COLOR-5714',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '蓝色 | V-DIAL-COLOR-5714',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Superocean Automatic 36',
      model_en: 'Superocean Automatic 36 (MY22)',
      case_en: 'Stainless steel',
      dial_color_en: 'Orange',
      type_en: ['Men', 'Women'],
      com_trace_story_en: null,
      pdp_release_ts: 1656583200,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1656583200,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1656583200,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1656583200,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDIwMg==',
      product_id: 'UHJvZHVjdDo0MjU4',
      name: {
        EN_US: 'Superocean Automatic 36',
        ES: 'Superocean Automatic 36',
        ZH_HANS: '超级海洋自动机械腕表36（Superocean Automatic 36）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 5150.0,
      price_range: '0-5999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/a17377211o1s1-soldier_e8a9e735_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/a17377211o1s1-soldier_e8a9e735.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736330,
      launch_date: 1656547200,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-A1737721/O515',
      model: {
        name: {
          EN_US: 'Superocean Automatic 36 (MY22)',
          ES: 'Superocean Automatic 36 (MY22)',
          ZH_HANS: '超级海洋自动机械腕表36（Superocean Automatic 36）',
        },
        slug: 'superocean-automatic-36-my22',
      },
      type: {
        EN_US: ['Men', 'Women'],
        ES: ['Hombre', 'Mujer'],
        ZH_HANS: ['男士', '女士'],
      },
      universe: 'SEA',
      head_reference: 'A1737721/O515',
      size: 36.0,
      size_range: '36-37',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/a17377211o1s1-on-wrist_0bab8737.png',
      collections: [
        {
          name: 'Superocean',
          slug: 'superocean',
          id: 'Q29sbGVjdGlvbjo3NQ==',
        },
      ],
      collection: 'Superocean',
      collection_id: 'Q29sbGVjdGlvbjo3NQ==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Orange | V-DIAL-COLOR-5800',
        ES: 'Naranja | V-DIAL-COLOR-5800',
        ZH_HANS: '橙色 | V-DIAL-COLOR-5800',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:26:28',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1656583200,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'A17377211O1S1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Superocean Automatic 36',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Superocean Automatic 36',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '超级海洋自动机械腕表36（Superocean Automatic 36）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Superocean',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Superocean',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Orange | V-DIAL-COLOR-5800',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Naranja | V-DIAL-COLOR-5800',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '橙色 | V-DIAL-COLOR-5800',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Superocean Automatic 36',
      model_en: 'Superocean Automatic 36 (MY22)',
      case_en: 'Stainless steel',
      dial_color_en: 'White',
      type_en: ['Men', 'Women'],
      com_trace_story_en: null,
      pdp_release_ts: 1656583200,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1656583200,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1656583200,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1656583200,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDE3MQ==',
      product_id: 'UHJvZHVjdDo0MjIz',
      name: {
        EN_US: 'Superocean Automatic 36',
        ES: 'Superocean Automatic 36',
        ZH_HANS: '超级海洋自动机械腕表36（Superocean Automatic 36）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 5150.0,
      price_range: '0-5999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/a17377211a1s1-soldier_5ac97383_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/a17377211a1s1-soldier_5ac97383.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736328,
      launch_date: 1656547200,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-A1737721/A844',
      model: {
        name: {
          EN_US: 'Superocean Automatic 36 (MY22)',
          ES: 'Superocean Automatic 36 (MY22)',
          ZH_HANS: '超级海洋自动机械腕表36（Superocean Automatic 36）',
        },
        slug: 'superocean-automatic-36-my22',
      },
      type: {
        EN_US: ['Men', 'Women'],
        ES: ['Hombre', 'Mujer'],
        ZH_HANS: ['男士', '女士'],
      },
      universe: 'SEA',
      head_reference: 'A1737721/A844',
      size: 36.0,
      size_range: '36-37',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/a17377211a1s1-on-wrist_7dffb94a.png',
      collections: [
        {
          name: 'Superocean',
          slug: 'superocean',
          id: 'Q29sbGVjdGlvbjo3NQ==',
        },
      ],
      collection: 'Superocean',
      collection_id: 'Q29sbGVjdGlvbjo3NQ==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'White | V-DIAL-COLOR-5926',
        ES: 'Blanco | V-DIAL-COLOR-5926',
        ZH_HANS: '白色 | V-DIAL-COLOR-5926',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:27:18',
      },
      widget_is_top_range: true,
      widget_stock_in_wholesaler_ids: [
        'US228516',
        'US102854',
        'US229999',
        'US231131',
        'US102435',
        'US221145',
        'US102977',
        'US102572',
        'US103013',
        'US102367',
        'US102815',
        'US102522',
        'US102515',
        'US102440',
        'US102758',
        'US207515',
        'US102517',
        'US102422',
        'US102477',
        'US102260',
        'US103016',
        'US103039',
        'US103014',
        'US102397',
        'US102306',
        'US102355',
        'US221448',
        'US102288',
        'US102746',
        'US102351',
        'US102875',
        'US102818',
        'US102310',
        'US222013',
        'US102715',
        'US102447',
        'US102718',
        'US102734',
        'US224448',
        'US102379',
        'US102465',
        'US102725',
        'US102399',
        'US102652',
        'US102821',
        'US102717',
        'US102347',
        'US102831',
        'US102366',
        'US102840',
        'US102805',
        'US220584',
        'US103008',
        'US102604',
        'US102764',
        'US102291',
        'US102709',
        'US102532',
        'US102329',
        'US102794',
        'US102368',
        'US102740',
        'US102722',
        'US102468',
        'US102453',
        'US102410',
        'US207516',
        'US102297',
        'US102516',
        'US102553',
        'US102503',
        'US102989',
        'US102421',
        'US102327',
        'US102506',
        'US102414',
        'US103034',
        'US102253',
        'US102978',
        'US102558',
        'US102787',
        'US224611',
        'US102314',
        'US102897',
        'US102728',
        'US102538',
        'US231542',
        'US231491',
        'US231826',
        'US230389',
        'US219712',
        'US103023',
        'US102531',
        'US102562',
        'US102889',
        'US102423',
        'US207953',
      ],
      widget_release_ts: 1656583200,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'A17377211A1S1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Superocean Automatic 36',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Superocean Automatic 36',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '超级海洋自动机械腕表36（Superocean Automatic 36）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Superocean',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Superocean',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'White | V-DIAL-COLOR-5926',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Blanco | V-DIAL-COLOR-5926',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '白色 | V-DIAL-COLOR-5926',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Superocean Automatic 44',
      model_en: 'Superocean Automatic 44 (MY22)',
      case_en: 'Stainless steel',
      dial_color_en: 'Green',
      type_en: ['Men'],
      com_trace_story_en: null,
      pdp_release_ts: 1656583200,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1656583200,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1656583200,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1656583200,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6MzIwNQ==',
      product_id: 'UHJvZHVjdDozMjEy',
      name: {
        EN_US: 'Superocean Automatic 44',
        ES: 'Superocean Automatic 44',
        ZH_HANS: '超级海洋自动机械腕表44（Superocean Automatic 44）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 5250.0,
      price_range: '0-5999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/a17376a31l1s1-soldier_a1b08ed3_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/a17376a31l1s1-soldier_a1b08ed3.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736328,
      launch_date: 1656547200,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-A17376A3/L576',
      model: {
        name: {
          EN_US: 'Superocean Automatic 44 (MY22)',
          ES: 'Superocean Automatic 44 (MY22)',
          ZH_HANS: '超级海洋自动机械腕表44（Superocean Automatic 44）',
        },
        slug: 'superocean-automatic-44-my22',
      },
      type: {
        EN_US: ['Men'],
        ES: ['Hombre'],
        ZH_HANS: ['男士'],
      },
      universe: 'SEA',
      head_reference: 'A17376A3/L576',
      size: 44.0,
      size_range: '44-45',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/a17376a31l1s1-on-wrist_dec14842.png',
      collections: [
        {
          name: 'Superocean',
          slug: 'superocean',
          id: 'Q29sbGVjdGlvbjo3NQ==',
        },
      ],
      collection: 'Superocean',
      collection_id: 'Q29sbGVjdGlvbjo3NQ==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Green | V-DIAL-COLOR-5765',
        ES: 'Verde | V-DIAL-COLOR-5765',
        ZH_HANS: '绿色 | V-DIAL-COLOR-5765',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:26:03',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1656583200,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'A17376A31L1S1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Superocean Automatic 44',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Superocean Automatic 44',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '超级海洋自动机械腕表44（Superocean Automatic 44）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Superocean',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Superocean',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Green | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Verde | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '绿色 | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Superocean Automatic 44',
      model_en: 'Superocean Automatic 44 (MY22)',
      case_en: 'Stainless steel',
      dial_color_en: 'Blue',
      type_en: ['Men'],
      com_trace_story_en: null,
      pdp_release_ts: 1656583200,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1656583200,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1656583200,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1656583200,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6MzIwNw==',
      product_id: 'UHJvZHVjdDozMjE0',
      name: {
        EN_US: 'Superocean Automatic 44',
        ES: 'Superocean Automatic 44',
        ZH_HANS: '超级海洋自动机械腕表44（Superocean Automatic 44）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 5250.0,
      price_range: '0-5999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/a17376211c1s1-soldier_313fc24d_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/a17376211c1s1-soldier_313fc24d.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736333,
      launch_date: 1656547200,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-A1737621/CB27',
      model: {
        name: {
          EN_US: 'Superocean Automatic 44 (MY22)',
          ES: 'Superocean Automatic 44 (MY22)',
          ZH_HANS: '超级海洋自动机械腕表44（Superocean Automatic 44）',
        },
        slug: 'superocean-automatic-44-my22',
      },
      type: {
        EN_US: ['Men'],
        ES: ['Hombre'],
        ZH_HANS: ['男士'],
      },
      universe: 'SEA',
      head_reference: 'A1737621/CB27',
      size: 44.0,
      size_range: '44-45',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/a17376211c1s1-on-wrist_cb46fde3.png',
      collections: [
        {
          name: 'Superocean',
          slug: 'superocean',
          id: 'Q29sbGVjdGlvbjo3NQ==',
        },
      ],
      collection: 'Superocean',
      collection_id: 'Q29sbGVjdGlvbjo3NQ==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Blue | V-DIAL-COLOR-5714',
        ES: 'Azul | V-DIAL-COLOR-5714',
        ZH_HANS: '蓝色 | V-DIAL-COLOR-5714',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:26:02',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1656583200,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'A17376211C1S1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Superocean Automatic 44',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Superocean Automatic 44',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '超级海洋自动机械腕表44（Superocean Automatic 44）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Superocean',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Superocean',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Blue | V-DIAL-COLOR-5714',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Azul | V-DIAL-COLOR-5714',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '蓝色 | V-DIAL-COLOR-5714',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Navitimer B01 Chronograph 43',
      model_en: 'Navitimer B01 Chronograph 43 (MY22)',
      case_en: '18k red gold',
      dial_color_en: 'Black',
      type_en: ['Men', 'Gold', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1648548000,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1648548000,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1648548000,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1648548000,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6MzYxMA==',
      product_id: 'UHJvZHVjdDozNjM0',
      name: {
        EN_US: 'Navitimer B01 Chronograph 43',
        ES: 'Navitimer B01 Chronograph 43',
        ZH_HANS: '航空计时B01计时腕表43（Navitimer B01 Chronograph 43）',
      },
      product_type: 'Watch',
      ecomm_available: false,
      phone_sale_available: true,
      price: 39700.0,
      price_range: '12000-inf',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/rb0138211b1r1-soldier_71a6a3a9_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/rb0138211b1r1-soldier_71a6a3a9.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736559,
      launch_date: 1648512000,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-RB013821/BI41',
      model: {
        name: {
          EN_US: 'Navitimer B01 Chronograph 43 (MY22)',
          ES: 'Navitimer B01 Chronograph 43',
          ZH_HANS: '航空计时B01计时腕表43（Navitimer B01 Chronograph 43）',
        },
        slug: 'navitimer-b01-chronograph-43-my22',
      },
      type: {
        EN_US: ['Men', 'Gold', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'Oro', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '金质', '百年灵自制机芯'],
      },
      universe: 'AIR',
      head_reference: 'RB013821/BI41',
      size: 43.0,
      size_range: '42-43',
      collections: [
        {
          name: 'Navitimer',
          slug: 'navitimer',
          id: 'Q29sbGVjdGlvbjo3NA==',
        },
      ],
      collection: 'Navitimer',
      collection_id: 'Q29sbGVjdGlvbjo3NA==',
      com_trace_story: null,
      case: {
        EN_US: '18k red gold | 18KREG',
        ES: 'Oro rojo de 18K | 18KREG',
        ZH_HANS: '18K红金 | 18KREG',
      },
      dial_color: {
        EN_US: 'Black | V-DIAL-COLOR-5686',
        ES: 'Negro | V-DIAL-COLOR-5686',
        ZH_HANS: '黑色 | V-DIAL-COLOR-5686',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        attrs_without_value: ['image_wrist_url'],
        updated_at_utc: '2025-05-09 19:26:34',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1648548000,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'RB0138211B1R1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Navitimer B01 Chronograph 43',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Navitimer B01 Chronograph 43',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '航空计时B01计时腕表43（Navitimer B01 Chronograph 43）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Navitimer',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Navitimer',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: '18k red gold | 18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Oro rojo de 18K | 18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '18K红金 | 18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Black | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Negro | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '黑色 | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Navitimer B01 Chronograph 41',
      model_en: 'Navitimer B01 Chronograph 41 (MY22)',
      case_en: 'Stainless steel',
      dial_color_en: 'Blue',
      type_en: ['Men', 'Women', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1648548000,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1648548000,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1648548000,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1648548000,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDQzNw==',
      product_id: 'UHJvZHVjdDo0NjU2',
      name: {
        EN_US: 'Navitimer B01 Chronograph 41',
        ES: 'Navitimer B01 Chronograph 41',
        ZH_HANS: '航空计时B01计时腕表41（Navitimer B01 Chronograph 41）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 9450.0,
      price_range: '9000-9999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/ab0139241c1p1-soldier_e6b09787_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0139241c1p1-soldier_e6b09787.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1720617862,
      launch_date: 1648512000,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-AB013924/CB16',
      model: {
        name: {
          EN_US: 'Navitimer B01 Chronograph 41 (MY22)',
          ES: 'Navitimer B01 Chronograph 41',
          ZH_HANS: '航空计时B01计时腕表41（Navitimer B01 Chronograph 41）',
        },
        slug: 'navitimer-b01-chronograph-41-my22',
      },
      type: {
        EN_US: ['Men', 'Women', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'Mujer', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '女士', '百年灵自制机芯'],
      },
      universe: 'AIR',
      head_reference: 'AB013924/CB16',
      size: 41.0,
      size_range: '40-41',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0139241c1p1-on-wrist_472c67ba.png',
      collections: [
        {
          name: 'Navitimer',
          slug: 'navitimer',
          id: 'Q29sbGVjdGlvbjo3NA==',
        },
      ],
      collection: 'Navitimer',
      collection_id: 'Q29sbGVjdGlvbjo3NA==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Blue | V-DIAL-COLOR-5714',
        ES: 'Azul | V-DIAL-COLOR-5714',
        ZH_HANS: '蓝色 | V-DIAL-COLOR-5714',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:26:25',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1648548000,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'AB0139241C1P1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Navitimer B01 Chronograph 41',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Navitimer B01 Chronograph 41',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '航空计时B01计时腕表41（Navitimer B01 Chronograph 41）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Navitimer',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Navitimer',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Blue | V-DIAL-COLOR-5714',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Azul | V-DIAL-COLOR-5714',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '蓝色 | V-DIAL-COLOR-5714',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Navitimer B01 Chronograph 41',
      model_en: 'Navitimer B01 Chronograph 41 (MY22)',
      case_en: 'Stainless steel',
      dial_color_en: 'Mint green',
      type_en: ['Men', 'Women', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1648548000,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1648548000,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1648548000,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1648548000,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6MzUxMA==',
      product_id: 'UHJvZHVjdDozNTMy',
      name: {
        EN_US: 'Navitimer B01 Chronograph 41',
        ES: 'Navitimer B01 Chronograph 41',
        ZH_HANS: '航空计时B01计时腕表41（Navitimer B01 Chronograph 41）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 9450.0,
      price_range: '9000-9999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/ab0139211l1p1-soldier_951226ab_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0139211l1p1-soldier_951226ab.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736473,
      launch_date: 1648512000,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-AB013921/L565',
      model: {
        name: {
          EN_US: 'Navitimer B01 Chronograph 41 (MY22)',
          ES: 'Navitimer B01 Chronograph 41',
          ZH_HANS: '航空计时B01计时腕表41（Navitimer B01 Chronograph 41）',
        },
        slug: 'navitimer-b01-chronograph-41-my22',
      },
      type: {
        EN_US: ['Men', 'Women', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'Mujer', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '女士', '百年灵自制机芯'],
      },
      universe: 'AIR',
      head_reference: 'AB013921/L565',
      size: 41.0,
      size_range: '40-41',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0139211l1p1-on-wrist_2e1924e6.png',
      collections: [
        {
          name: 'Navitimer',
          slug: 'navitimer',
          id: 'Q29sbGVjdGlvbjo3NA==',
        },
      ],
      collection: 'Navitimer',
      collection_id: 'Q29sbGVjdGlvbjo3NA==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Mint green | V-DIAL-COLOR-8888',
        ES: 'Verde menta | V-DIAL-COLOR-8888',
        ZH_HANS: '薄荷绿 | V-DIAL-COLOR-8888',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:26:18',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1648548000,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'AB0139211L1P1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Navitimer B01 Chronograph 41',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Navitimer B01 Chronograph 41',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '航空计时B01计时腕表41（Navitimer B01 Chronograph 41）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Navitimer',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Navitimer',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Mint green | V-DIAL-COLOR-8888',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Verde menta | V-DIAL-COLOR-8888',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '薄荷绿 | V-DIAL-COLOR-8888',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Navitimer B01 Chronograph 43',
      model_en: 'Navitimer B01 Chronograph 43 (MY22)',
      case_en: 'Stainless steel',
      dial_color_en: 'Mint green',
      type_en: ['Men', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1648548000,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1648548000,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1648548000,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1648548000,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDQxMA==',
      product_id: 'UHJvZHVjdDo0NjI5',
      name: {
        EN_US: 'Navitimer B01 Chronograph 43',
        ES: 'Navitimer B01 Chronograph 43',
        ZH_HANS: '航空计时B01计时腕表43（Navitimer B01 Chronograph 43）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 9550.0,
      price_range: '9000-9999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/ab0138241l1p1-soldier_a2ebe756_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0138241l1p1-soldier_a2ebe756.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1720617860,
      launch_date: 1648512000,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-AB013824/L564',
      model: {
        name: {
          EN_US: 'Navitimer B01 Chronograph 43 (MY22)',
          ES: 'Navitimer B01 Chronograph 43',
          ZH_HANS: '航空计时B01计时腕表43（Navitimer B01 Chronograph 43）',
        },
        slug: 'navitimer-b01-chronograph-43-my22',
      },
      type: {
        EN_US: ['Men', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '百年灵自制机芯'],
      },
      universe: 'AIR',
      head_reference: 'AB013824/L564',
      size: 43.0,
      size_range: '42-43',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0138241l1p1-on-wrist_07572cc0.png',
      collections: [
        {
          name: 'Navitimer',
          slug: 'navitimer',
          id: 'Q29sbGVjdGlvbjo3NA==',
        },
      ],
      collection: 'Navitimer',
      collection_id: 'Q29sbGVjdGlvbjo3NA==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Mint green | V-DIAL-COLOR-8888',
        ES: 'Verde menta | V-DIAL-COLOR-8888',
        ZH_HANS: '薄荷绿 | V-DIAL-COLOR-8888',
      },
      marketing_status: [
        'Online Exclusive',
        'Boutique Exclusive',
        'Boutique & Online Exclusive',
      ],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:26:00',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1648548000,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'AB0138241L1P1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Navitimer B01 Chronograph 43',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Navitimer B01 Chronograph 43',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '航空计时B01计时腕表43（Navitimer B01 Chronograph 43）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Navitimer',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Navitimer',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Mint green | V-DIAL-COLOR-8888',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Verde menta | V-DIAL-COLOR-8888',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '薄荷绿 | V-DIAL-COLOR-8888',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Navitimer B01 Chronograph 43',
      model_en: 'Navitimer B01 Chronograph 43 (MY22)',
      case_en: 'Stainless steel',
      dial_color_en: 'Copper',
      type_en: ['Men', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1648548000,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1648548000,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1648548000,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1648548000,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6MzQ3NQ==',
      product_id: 'UHJvZHVjdDozNDk3',
      name: {
        EN_US: 'Navitimer B01 Chronograph 43',
        ES: 'Navitimer B01 Chronograph 43',
        ZH_HANS: '航空计时B01计时腕表43（Navitimer B01 Chronograph 43）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 9550.0,
      price_range: '9000-9999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/ab0138241k1p1-soldier_c8d79e43_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0138241k1p1-soldier_c8d79e43.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736472,
      launch_date: 1648512000,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-AB013824/K541',
      model: {
        name: {
          EN_US: 'Navitimer B01 Chronograph 43 (MY22)',
          ES: 'Navitimer B01 Chronograph 43',
          ZH_HANS: '航空计时B01计时腕表43（Navitimer B01 Chronograph 43）',
        },
        slug: 'navitimer-b01-chronograph-43-my22',
      },
      type: {
        EN_US: ['Men', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '百年灵自制机芯'],
      },
      universe: 'AIR',
      head_reference: 'AB013824/K541',
      size: 43.0,
      size_range: '42-43',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0138241k1p1-on-wrist_80a1b050.png',
      collections: [
        {
          name: 'Navitimer',
          slug: 'navitimer',
          id: 'Q29sbGVjdGlvbjo3NA==',
        },
      ],
      collection: 'Navitimer',
      collection_id: 'Q29sbGVjdGlvbjo3NA==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Copper | V-DIAL-COLO-999',
        ES: 'Cobre | V-DIAL-COLO-999',
        ZH_HANS: '铜色 | V-DIAL-COLO-999',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:20:58',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1648548000,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'AB0138241K1P1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Navitimer B01 Chronograph 43',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Navitimer B01 Chronograph 43',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '航空计时B01计时腕表43（Navitimer B01 Chronograph 43）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Navitimer',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Navitimer',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Copper | V-DIAL-COLO-999',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Cobre | V-DIAL-COLO-999',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '铜色 | V-DIAL-COLO-999',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Navitimer B01 Chronograph 43',
      model_en: 'Navitimer B01 Chronograph 43 (MY22)',
      case_en: 'Stainless steel',
      dial_color_en: 'Ice blue',
      type_en: ['Men', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1648548000,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1648548000,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1648548000,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1648548000,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6Mzk0MQ==',
      product_id: 'UHJvZHVjdDozOTc3',
      name: {
        EN_US: 'Navitimer B01 Chronograph 43',
        ES: 'Navitimer B01 Chronograph 43',
        ZH_HANS: '航空计时B01计时腕表43（Navitimer B01 Chronograph 43）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 9550.0,
      price_range: '9000-9999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/ab0138241c1p1-soldier_193216c9_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0138241c1p1-soldier_193216c9.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736474,
      launch_date: 1648512000,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-AB013824/CB22',
      model: {
        name: {
          EN_US: 'Navitimer B01 Chronograph 43 (MY22)',
          ES: 'Navitimer B01 Chronograph 43',
          ZH_HANS: '航空计时B01计时腕表43（Navitimer B01 Chronograph 43）',
        },
        slug: 'navitimer-b01-chronograph-43-my22',
      },
      type: {
        EN_US: ['Men', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '百年灵自制机芯'],
      },
      universe: 'AIR',
      head_reference: 'AB013824/CB22',
      size: 43.0,
      size_range: '42-43',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0138241c1p1-on-wrist_cb476cad.png',
      collections: [
        {
          name: 'Navitimer',
          slug: 'navitimer',
          id: 'Q29sbGVjdGlvbjo3NA==',
        },
      ],
      collection: 'Navitimer',
      collection_id: 'Q29sbGVjdGlvbjo3NA==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Ice blue | V-DIAL-COLOR-1111',
        ES: 'Azul hielo | V-DIAL-COLOR-1111',
        ZH_HANS: '冰蓝 | V-DIAL-COLOR-1111',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:24:46',
      },
      widget_is_top_range: true,
      widget_stock_in_wholesaler_ids: ['US102558'],
      widget_release_ts: 1648548000,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'AB0138241C1P1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Navitimer B01 Chronograph 43',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Navitimer B01 Chronograph 43',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '航空计时B01计时腕表43（Navitimer B01 Chronograph 43）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Navitimer',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Navitimer',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Ice blue | V-DIAL-COLOR-1111',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Azul hielo | V-DIAL-COLOR-1111',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '冰蓝 | V-DIAL-COLOR-1111',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Navitimer B01 Chronograph 43',
      model_en: 'Navitimer B01 Chronograph 43 (MY22)',
      case_en: 'Stainless steel',
      dial_color_en: 'Black',
      type_en: ['Men', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1735426800,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1648548000,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1648548000,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1648548000,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6MzUyMg==',
      product_id: 'UHJvZHVjdDozNTQ0',
      name: {
        EN_US: 'Navitimer B01 Chronograph 43',
        ES: 'Navitimer B01 Chronograph 43',
        ZH_HANS: '航空计时B01计时腕表43（Navitimer B01 Chronograph 43）',
      },
      product_type: 'Watch',
      ecomm_available: false,
      phone_sale_available: true,
      price: 9950.0,
      price_range: '9000-9999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/ab0138211b1a1-soldier_47c7c346_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0138211b1a1-soldier_47c7c346.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736472,
      launch_date: 1648512000,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-AB013821/BI17',
      model: {
        name: {
          EN_US: 'Navitimer B01 Chronograph 43 (MY22)',
          ES: 'Navitimer B01 Chronograph 43',
          ZH_HANS: '航空计时B01计时腕表43（Navitimer B01 Chronograph 43）',
        },
        slug: 'navitimer-b01-chronograph-43-my22',
      },
      type: {
        EN_US: ['Men', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '百年灵自制机芯'],
      },
      universe: 'AIR',
      head_reference: 'AB013821/BI17',
      size: 43.0,
      size_range: '42-43',
      collections: [
        {
          name: 'Navitimer',
          slug: 'navitimer',
          id: 'Q29sbGVjdGlvbjo3NA==',
        },
      ],
      collection: 'Navitimer',
      collection_id: 'Q29sbGVjdGlvbjo3NA==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Black | V-DIAL-COLOR-5686',
        ES: 'Negro | V-DIAL-COLOR-5686',
        ZH_HANS: '黑色 | V-DIAL-COLOR-5686',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        attrs_without_value: ['image_wrist_url'],
        updated_at_utc: '2025-05-09 19:25:22',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1735426800,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'AB0138211B1A1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Navitimer B01 Chronograph 43',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Navitimer B01 Chronograph 43',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '航空计时B01计时腕表43（Navitimer B01 Chronograph 43）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Navitimer',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Navitimer',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Black | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Negro | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '黑色 | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Navitimer B01 Chronograph 46',
      model_en: 'Navitimer B01 Chronograph 46 (MY22)',
      case_en: 'Stainless steel',
      dial_color_en: 'Green',
      type_en: ['Men', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1648548000,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1648548000,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1648548000,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1648548000,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDQ3MQ==',
      product_id: 'UHJvZHVjdDo0Njkw',
      name: {
        EN_US: 'Navitimer B01 Chronograph 46',
        ES: 'Navitimer B01 Chronograph 46',
        ZH_HANS: '航空计时B01计时腕表46（Navitimer B01 Chronograph 46）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 9650.0,
      price_range: '9000-9999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/ab0137241l1p1-soldier_27c5b65e_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0137241l1p1-soldier_27c5b65e.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1720617857,
      launch_date: 1648512000,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-AB013724/L566',
      model: {
        name: {
          EN_US: 'Navitimer B01 Chronograph 46 (MY22)',
          ES: 'Navitimer B01 Chronograph 46',
          ZH_HANS: '航空计时B01计时腕表46（Navitimer B01 Chronograph 46）',
        },
        slug: 'navitimer-b01-chronograph-46-my22',
      },
      type: {
        EN_US: ['Men', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '百年灵自制机芯'],
      },
      universe: 'AIR',
      head_reference: 'AB013724/L566',
      size: 46.0,
      size_range: '46-47',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0137241l1p1-on-wrist_2c6bb5ac.png',
      collections: [
        {
          name: 'Navitimer',
          slug: 'navitimer',
          id: 'Q29sbGVjdGlvbjo3NA==',
        },
      ],
      collection: 'Navitimer',
      collection_id: 'Q29sbGVjdGlvbjo3NA==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Green | V-DIAL-COLOR-5765',
        ES: 'Verde | V-DIAL-COLOR-5765',
        ZH_HANS: '绿色 | V-DIAL-COLOR-5765',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:26:05',
      },
      widget_is_top_range: true,
      widget_stock_in_wholesaler_ids: ['US102558'],
      widget_release_ts: 1648548000,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'AB0137241L1P1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Navitimer B01 Chronograph 46',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Navitimer B01 Chronograph 46',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '航空计时B01计时腕表46（Navitimer B01 Chronograph 46）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Navitimer',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Navitimer',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Green | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Verde | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '绿色 | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Navitimer B01 Chronograph 46',
      model_en: 'Navitimer B01 Chronograph 46 (MY22)',
      case_en: 'Stainless steel',
      dial_color_en: 'Blue',
      type_en: ['Men', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1648548000,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1648548000,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1648548000,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1648548000,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6MzI3Ng==',
      product_id: 'UHJvZHVjdDozMjkw',
      name: {
        EN_US: 'Navitimer B01 Chronograph 46',
        ES: 'Navitimer B01 Chronograph 46',
        ZH_HANS: '航空计时B01计时腕表46（Navitimer B01 Chronograph 46）',
      },
      product_type: 'Watch',
      ecomm_available: false,
      phone_sale_available: true,
      price: 10050.0,
      price_range: '10000-11999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/ab0137211c1a1-soldier_e9f09822_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0137211c1a1-soldier_e9f09822.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736448,
      launch_date: 1648512000,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-AB013721/CA99',
      model: {
        name: {
          EN_US: 'Navitimer B01 Chronograph 46 (MY22)',
          ES: 'Navitimer B01 Chronograph 46',
          ZH_HANS: '航空计时B01计时腕表46（Navitimer B01 Chronograph 46）',
        },
        slug: 'navitimer-b01-chronograph-46-my22',
      },
      type: {
        EN_US: ['Men', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '百年灵自制机芯'],
      },
      universe: 'AIR',
      head_reference: 'AB013721/CA99',
      size: 46.0,
      size_range: '46-47',
      collections: [
        {
          name: 'Navitimer',
          slug: 'navitimer',
          id: 'Q29sbGVjdGlvbjo3NA==',
        },
      ],
      collection: 'Navitimer',
      collection_id: 'Q29sbGVjdGlvbjo3NA==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Blue | V-DIAL-COLOR-5714',
        ES: 'Azul | V-DIAL-COLOR-5714',
        ZH_HANS: '蓝色 | V-DIAL-COLOR-5714',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        attrs_without_value: ['image_wrist_url'],
        updated_at_utc: '2025-05-09 19:24:22',
      },
      widget_is_top_range: true,
      widget_stock_in_wholesaler_ids: [
        'US228516',
        'US102854',
        'US229999',
        'US231131',
        'US102435',
        'US221145',
        'US102977',
        'US102572',
        'US103013',
        'US102367',
        'US102815',
        'US102522',
        'US102515',
        'US102440',
        'US102758',
        'US207515',
        'US102517',
        'US102422',
        'US102477',
        'US102260',
        'US103016',
        'US103039',
        'US103014',
        'US102397',
        'US102306',
        'US102355',
        'US221448',
        'US102288',
        'US102746',
        'US102351',
        'US102875',
        'US102818',
        'US102310',
        'US222013',
        'US102715',
        'US102447',
        'US102718',
        'US102734',
        'US224448',
        'US102379',
        'US102465',
        'US102725',
        'US102399',
        'US102652',
        'US102821',
        'US102717',
        'US102347',
        'US102831',
        'US102366',
        'US102840',
        'US102805',
        'US220584',
        'US103008',
        'US102604',
        'US102764',
        'US102291',
        'US102709',
        'US102532',
        'US102329',
        'US102794',
        'US102368',
        'US102740',
        'US102722',
        'US102468',
        'US102453',
        'US102410',
        'US207516',
        'US102297',
        'US102516',
        'US102553',
        'US102503',
        'US102989',
        'US102421',
        'US102327',
        'US102506',
        'US102414',
        'US103034',
        'US102253',
        'US102978',
        'US102558',
        'US102787',
        'US224611',
        'US102314',
        'US102897',
        'US102728',
        'US102538',
        'US231542',
        'US231491',
        'US231826',
        'US230389',
        'US219712',
        'US103023',
        'US102531',
        'US102562',
        'US102889',
        'US102423',
        'US207953',
      ],
      widget_release_ts: 1648548000,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'AB0137211C1A1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Navitimer B01 Chronograph 46',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Navitimer B01 Chronograph 46',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '航空计时B01计时腕表46（Navitimer B01 Chronograph 46）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Navitimer',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Navitimer',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Blue | V-DIAL-COLOR-5714',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Azul | V-DIAL-COLOR-5714',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '蓝色 | V-DIAL-COLOR-5714',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Navitimer B01 Chronograph 46',
      model_en: 'Navitimer B01 Chronograph 46 (MY22)',
      case_en: 'Stainless steel',
      dial_color_en: 'Black',
      type_en: ['Men', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1648548000,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1648548000,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1648548000,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1648548000,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6Mzk4Mw==',
      product_id: 'UHJvZHVjdDo0MDIw',
      name: {
        EN_US: 'Navitimer B01 Chronograph 46',
        ES: 'Navitimer B01 Chronograph 46',
        ZH_HANS: '航空计时B01计时腕表46（Navitimer B01 Chronograph 46）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 9650.0,
      price_range: '9000-9999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/ab0137211b1p1-soldier_6f1dddba_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0137211b1p1-soldier_6f1dddba.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736447,
      launch_date: 1648512000,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-AB013721/BI23',
      model: {
        name: {
          EN_US: 'Navitimer B01 Chronograph 46 (MY22)',
          ES: 'Navitimer B01 Chronograph 46',
          ZH_HANS: '航空计时B01计时腕表46（Navitimer B01 Chronograph 46）',
        },
        slug: 'navitimer-b01-chronograph-46-my22',
      },
      type: {
        EN_US: ['Men', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '百年灵自制机芯'],
      },
      universe: 'AIR',
      head_reference: 'AB013721/BI23',
      size: 46.0,
      size_range: '46-47',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0137211b1p1-on-wrist_d7016df8.png',
      collections: [
        {
          name: 'Navitimer',
          slug: 'navitimer',
          id: 'Q29sbGVjdGlvbjo3NA==',
        },
      ],
      collection: 'Navitimer',
      collection_id: 'Q29sbGVjdGlvbjo3NA==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Black | V-DIAL-COLOR-5686',
        ES: 'Negro | V-DIAL-COLOR-5686',
        ZH_HANS: '黑色 | V-DIAL-COLOR-5686',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:24:02',
      },
      widget_is_top_range: true,
      widget_stock_in_wholesaler_ids: [
        'US228516',
        'US102854',
        'US229999',
        'US231131',
        'US102435',
        'US221145',
        'US102977',
        'US102572',
        'US103013',
        'US102367',
        'US102815',
        'US102522',
        'US102515',
        'US102440',
        'US102758',
        'US207515',
        'US102517',
        'US102422',
        'US102477',
        'US102260',
        'US103016',
        'US103039',
        'US103014',
        'US102397',
        'US102306',
        'US102355',
        'US221448',
        'US102288',
        'US102746',
        'US102351',
        'US102875',
        'US102818',
        'US102310',
        'US222013',
        'US102715',
        'US102447',
        'US102718',
        'US102734',
        'US224448',
        'US102379',
        'US102465',
        'US102725',
        'US102399',
        'US102652',
        'US102821',
        'US102717',
        'US102347',
        'US102831',
        'US102366',
        'US102840',
        'US102805',
        'US220584',
        'US103008',
        'US102604',
        'US102764',
        'US102291',
        'US102709',
        'US102532',
        'US102329',
        'US102794',
        'US102368',
        'US102740',
        'US102722',
        'US102468',
        'US102453',
        'US102410',
        'US207516',
        'US102297',
        'US102516',
        'US102553',
        'US102503',
        'US102989',
        'US102421',
        'US102327',
        'US102506',
        'US102414',
        'US103034',
        'US102253',
        'US102978',
        'US102787',
        'US224611',
        'US102314',
        'US102897',
        'US102728',
        'US102538',
        'US231542',
        'US231491',
        'US231826',
        'US230389',
        'US219712',
        'US103023',
        'US102531',
        'US102562',
        'US102889',
        'US102423',
        'US207953',
      ],
      widget_release_ts: 1648548000,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'AB0137211B1P1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Navitimer B01 Chronograph 46',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Navitimer B01 Chronograph 46',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '航空计时B01计时腕表46（Navitimer B01 Chronograph 46）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Navitimer',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Navitimer',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Black | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Negro | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '黑色 | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Super AVI B04 Chronograph GMT 46 Curtiss Warhawk',
      model_en: 'Super AVI B04 Chronograph GMT 46',
      case_en: 'Stainless steel',
      dial_color_en: 'Green',
      type_en: ['Men', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1637146800,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1637146800,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1637146800,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1637146800,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6MzQ4Nw==',
      product_id: 'UHJvZHVjdDozNTA5',
      name: {
        EN_US: 'Super AVI B04 Chronograph GMT 46 Curtiss Warhawk',
        ES: 'Super AVI B04 Chronograph GMT 46 Curtiss Warhawk',
        ZH_HANS:
          '超级AVI双时区B04计时腕表46柯蒂斯战鹰版（Super AVI B04 Chronograph GMT 46 Curtiss Warhawk）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 10800.0,
      price_range: '10000-11999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/ab04452a1l1x1-soldier_cef0df35_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab04452a1l1x1-soldier_cef0df35.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736476,
      launch_date: 1637107200,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-AB04452A/L561',
      model: {
        name: {
          EN_US: 'Super AVI B04 Chronograph GMT 46',
          ES: 'Super AVI B04 Chronograph GMT 46',
          ZH_HANS:
            '超级AVI双时区B04计时腕表46（Super AVI B04 Chronograph GMT 46）',
        },
        slug: 'super-avi-b04-chronograph-gmt-46',
      },
      type: {
        EN_US: ['Men', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '百年灵自制机芯'],
      },
      universe: 'AIR',
      head_reference: 'AB04452A/L561',
      size: 46.0,
      size_range: '46-47',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab04452a1l1x1-on-wrist_dc5aa16b.png',
      collections: [
        {
          name: 'Classic AVI',
          slug: 'classic-avi',
          id: 'Q29sbGVjdGlvbjo3Nw==',
        },
      ],
      collection: 'Classic AVI',
      collection_id: 'Q29sbGVjdGlvbjo3Nw==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Green | V-DIAL-COLOR-5765',
        ES: 'Verde | V-DIAL-COLOR-5765',
        ZH_HANS: '绿色 | V-DIAL-COLOR-5765',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:19:31',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1637146800,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'AB04452A1L1X1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Super AVI B04 Chronograph GMT 46 Curtiss Warhawk',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Super AVI B04 Chronograph GMT 46 Curtiss Warhawk',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value:
              '超级AVI双时区B04计时腕表46柯蒂斯战鹰版（Super AVI B04 Chronograph GMT 46 Curtiss Warhawk）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Classic AVI',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Classic AVI',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Green | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Verde | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '绿色 | V-DIAL-COLOR-5765',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Super Chronomat B01 44',
      model_en: 'Super Chronomat B01 44',
      case_en: 'Stainless steel',
      dial_color_en: 'Anthracite',
      type_en: ['Men', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1637060400,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1637060400,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1637060400,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1637060400,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6MzQ1Mw==',
      product_id: 'UHJvZHVjdDozNDc0',
      name: {
        EN_US: 'Super Chronomat B01 44',
        ES: 'Super Chronomat B01 44',
        ZH_HANS: '超级机械计时B01腕表44（Super Chronomat B01 44）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 9800.0,
      price_range: '9000-9999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/ab0136251b2s1-soldier_3e3c684b_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0136251b2s1-soldier_3e3c684b.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736443,
      launch_date: 1637020800,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-AB013625/BI55',
      model: {
        name: {
          EN_US: 'Super Chronomat B01 44',
          ES: 'Super Chronomat B01 44',
          ZH_HANS: '超级机械计时B01腕表44（Super Chronomat B01 44）',
        },
        slug: 'super-chronomat-b01-44',
      },
      type: {
        EN_US: ['Men', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '百年灵自制机芯'],
      },
      universe: 'LAND',
      head_reference: 'AB013625/BI55',
      size: 44.0,
      size_range: '44-45',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab0136251b2s1-on-wrist_f6b5c529.png',
      collections: [
        {
          name: 'Chronomat',
          slug: 'chronomat',
          id: 'Q29sbGVjdGlvbjo3Ng==',
        },
      ],
      collection: 'Chronomat',
      collection_id: 'Q29sbGVjdGlvbjo3Ng==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Anthracite | V-DIAL-COLOR-5664',
        ES: 'Antracita | V-DIAL-COLOR-5664',
        ZH_HANS: '烟煤色 | V-DIAL-COLOR-5664',
      },
      marketing_status: ['Core', 'Boutique & Online Exclusive'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:33:35',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1637060400,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'AB0136251B2S1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Super Chronomat B01 44',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Super Chronomat B01 44',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '超级机械计时B01腕表44（Super Chronomat B01 44）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Chronomat',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Chronomat',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Anthracite | V-DIAL-COLOR-5664',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Antracita | V-DIAL-COLOR-5664',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '烟煤色 | V-DIAL-COLOR-5664',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Endurance Pro IRONMAN®',
      model_en: 'Endurance Pro',
      case_en: 'Breitlight®',
      dial_color_en: 'Red',
      type_en: ['Men', 'Professional'],
      com_trace_story_en: null,
      pdp_release_ts: 32503680000,
      pdp_expire_ts: 32503680000,
      pdp_preview: false,
      plp_release_ts: 1623751200,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1623751200,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1623751200,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6MzMzNQ==',
      product_id: 'UHJvZHVjdDozMzU0',
      name: {
        EN_US: 'Endurance Pro 44 IRONMAN®',
        ES: 'Endurance Pro 44 IRONMAN®',
        ZH_HANS: '专业耐力腕表IRONMAN®特别版（Endurance Pro 44 IRONMAN®）',
      },
      product_type: 'Watch',
      ecomm_available: false,
      phone_sale_available: true,
      price: 3600.0,
      price_range: '0-5999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/x823109a1k1s1-soldier_0e2f0c78_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/x823109a1k1s1-soldier_0e2f0c78.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736592,
      launch_date: 1623715200,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-X823109A/K539',
      model: {
        name: {
          EN_US: 'Endurance Pro',
          ES: 'Endurance Pro',
          ZH_HANS: '专业耐力腕表（Endurance Pro）',
        },
        slug: 'endurance-pro',
      },
      type: {
        EN_US: ['Men', 'Professional'],
        ES: ['Hombre', 'Profesional'],
        ZH_HANS: ['男士', '专业'],
      },
      universe: 'Professional',
      head_reference: 'X823109A/K539',
      size: 44.0,
      size_range: '44-45',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/x823109a1k1s1-on-wrist_d323a6e9.png',
      collections: [
        {
          name: 'Professional',
          slug: 'professional',
          id: 'Q29sbGVjdGlvbjo3OQ==',
        },
      ],
      collection: 'Professional',
      collection_id: 'Q29sbGVjdGlvbjo3OQ==',
      com_trace_story: null,
      case: {
        EN_US: 'Breitlight® | BREITL',
        ES: 'Breitlight® | BREITL',
        ZH_HANS: 'Breitlight® | BREITL',
      },
      dial_color: {
        EN_US: 'Red | V-DIAL-COLOR-556644',
        ES: 'Rojo | V-DIAL-COLOR-556644',
        ZH_HANS: '紅 | V-DIAL-COLOR-556644',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:19:07',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 32503680000,
      widget_expire_ts: 32503680000,
      widget_preview: false,
      objectID: 'X823109A1K1S1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Endurance Pro 44 IRONMAN®',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Endurance Pro 44 IRONMAN®',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '专业耐力腕表IRONMAN®特别版（Endurance Pro 44 IRONMAN®）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Professional',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Professional',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Breitlight® | BREITL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Breitlight® | BREITL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: 'Breitlight® | BREITL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Red | V-DIAL-COLOR-556644',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Rojo | V-DIAL-COLOR-556644',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '紅 | V-DIAL-COLOR-556644',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Super Chronomat B01 44',
      model_en: 'Super Chronomat B01 44',
      case_en: '18k red gold',
      dial_color_en: 'Brown',
      type_en: ['Men', 'Gold', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1620295200,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1620295200,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1620295200,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1620295200,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDQ2OA==',
      product_id: 'UHJvZHVjdDo0Njg3',
      name: {
        EN_US: 'Super Chronomat B01 44',
        ES: 'Super Chronomat B01 44',
        ZH_HANS: '超级机械计时B01腕表44（Super Chronomat B01 44）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 26400.0,
      price_range: '12000-inf',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/rb0136e31q1s1-soldier_fd098967_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/rb0136e31q1s1-soldier_fd098967.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1720617916,
      launch_date: 1620259200,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-RB0136E3/Q632',
      model: {
        name: {
          EN_US: 'Super Chronomat B01 44',
          ES: 'Super Chronomat B01 44',
          ZH_HANS: '超级机械计时B01腕表44（Super Chronomat B01 44）',
        },
        slug: 'super-chronomat-b01-44',
      },
      type: {
        EN_US: ['Men', 'Gold', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'Oro', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '金质', '百年灵自制机芯'],
      },
      universe: 'LAND',
      head_reference: 'RB0136E3/Q632',
      size: 44.0,
      size_range: '44-45',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/rb0136e31q1s1-on-wrist_5e781b85.png',
      collections: [
        {
          name: 'Chronomat',
          slug: 'chronomat',
          id: 'Q29sbGVjdGlvbjo3Ng==',
        },
      ],
      collection: 'Chronomat',
      collection_id: 'Q29sbGVjdGlvbjo3Ng==',
      com_trace_story: null,
      case: {
        EN_US: '18k red gold | 18KREG',
        ES: 'Oro rojo de 18K | 18KREG',
        ZH_HANS: '18K红金 | 18KREG',
      },
      dial_color: {
        EN_US: 'Brown | V-DIAL-COLOR-5723',
        ES: 'Marrón | V-DIAL-COLOR-5723',
        ZH_HANS: '棕色 | V-DIAL-COLOR-5723',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:16:09',
      },
      widget_is_top_range: true,
      widget_stock_in_wholesaler_ids: [
        'US228516',
        'US102854',
        'US229999',
        'US231131',
        'US102435',
        'US221145',
        'US102977',
        'US102572',
        'US103013',
        'US102367',
        'US102815',
        'US102522',
        'US102515',
        'US102440',
        'US102758',
        'US207515',
        'US102517',
        'US102422',
        'US102477',
        'US102260',
        'US103016',
        'US103039',
        'US103014',
        'US102397',
        'US102306',
        'US102355',
        'US221448',
        'US102288',
        'US102746',
        'US102351',
        'US102875',
        'US102818',
        'US102310',
        'US222013',
        'US102715',
        'US102447',
        'US102718',
        'US102734',
        'US224448',
        'US102379',
        'US102465',
        'US102725',
        'US102399',
        'US102652',
        'US102821',
        'US102717',
        'US102347',
        'US102831',
        'US102366',
        'US102840',
        'US102805',
        'US220584',
        'US103008',
        'US102604',
        'US102764',
        'US102291',
        'US102709',
        'US102532',
        'US102329',
        'US102794',
        'US102368',
        'US102740',
        'US102722',
        'US102468',
        'US102453',
        'US102410',
        'US207516',
        'US102297',
        'US102516',
        'US102553',
        'US102503',
        'US102989',
        'US102421',
        'US102327',
        'US102506',
        'US102414',
        'US103034',
        'US102253',
        'US102978',
        'US102787',
        'US224611',
        'US102314',
        'US102897',
        'US102728',
        'US102538',
        'US231542',
        'US231491',
        'US231826',
        'US230389',
        'US219712',
        'US103023',
        'US102531',
        'US102562',
        'US102889',
        'US102423',
        'US207953',
      ],
      widget_release_ts: 1620295200,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'RB0136E31Q1S1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Super Chronomat B01 44',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Super Chronomat B01 44',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '超级机械计时B01腕表44（Super Chronomat B01 44）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Chronomat',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Chronomat',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: '18k red gold | 18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Oro rojo de 18K | 18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '18K红金 | 18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Brown | V-DIAL-COLOR-5723',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Marrón | V-DIAL-COLOR-5723',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '棕色 | V-DIAL-COLOR-5723',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Premier B25 Datora 42',
      model_en: 'Premier B25 Datora 42',
      case_en: '18k red gold',
      dial_color_en: 'Cream',
      type_en: ['Men', 'Gold', 'Women', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1617703200,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1617703200,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1617703200,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1617703200,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6MzU5NA==',
      product_id: 'UHJvZHVjdDozNjE4',
      name: {
        EN_US: 'Premier B25 Datora 42',
        ES: 'Premier B25 Datora 42',
        ZH_HANS: '璞雅文化B25 Datora腕表42（Premier B25 Datora 42）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 26950.0,
      price_range: '12000-inf',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/rb2510371g1p1-soldier_800b6fd0_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/rb2510371g1p1-soldier_800b6fd0.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736551,
      launch_date: 1617667200,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-RB251037/G872',
      model: {
        name: {
          EN_US: 'Premier B25 Datora 42',
          ES: 'Premier B25 Datora 42',
          ZH_HANS: '璞雅文化B25 Datora腕表42（Premier B25 Datora 42）',
        },
        slug: 'premier-b25-datora-42',
      },
      type: {
        EN_US: ['Men', 'Gold', 'Women', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'Oro', 'Mujer', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '金质', '女士', '百年灵自制机芯'],
      },
      universe: 'LAND',
      head_reference: 'RB251037/G872',
      size: 42.0,
      size_range: '42-43',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/rb2510371g1p1-on-wrist_032650cb.png',
      collections: [
        {
          name: 'Premier',
          slug: 'premier',
          id: 'Q29sbGVjdGlvbjo3Mw==',
        },
      ],
      collection: 'Premier',
      collection_id: 'Q29sbGVjdGlvbjo3Mw==',
      com_trace_story: null,
      case: {
        EN_US: '18k red gold | 18KREG',
        ES: 'Oro rojo de 18K | 18KREG',
        ZH_HANS: '18K红金 | 18KREG',
      },
      dial_color: {
        EN_US: 'Cream | V-DIAL-COLOR-5842',
        ES: 'Crema | V-DIAL-COLOR-5842',
        ZH_HANS: '奶油色 | V-DIAL-COLOR-5842',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:16:05',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1617703200,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'RB2510371G1P1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Premier B25 Datora 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Premier B25 Datora 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '璞雅文化B25 Datora腕表42（Premier B25 Datora 42）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Premier',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Premier',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: '18k red gold | 18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Oro rojo de 18K | 18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '18K红金 | 18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Cream | V-DIAL-COLOR-5842',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Crema | V-DIAL-COLOR-5842',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '奶油色 | V-DIAL-COLOR-5842',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Premier B15 Duograph 42',
      model_en: 'Premier B15 Duograph 42',
      case_en: '18k red gold',
      dial_color_en: 'Black',
      type_en: ['Men', 'Gold', 'Women', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1617703200,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1617703200,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1617703200,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1617703200,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6Mzc1Nw==',
      product_id: 'UHJvZHVjdDozNzg2',
      name: {
        EN_US: 'Premier B15 Duograph 42',
        ES: 'Premier B15 Duograph 42',
        ZH_HANS: '璞雅文化B15 Duograph腕表42（Premier B15 Duograph 42）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 22850.0,
      price_range: '12000-inf',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/rb1510251b1p1-soldier_0b49b7c3_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/rb1510251b1p1-soldier_0b49b7c3.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736550,
      launch_date: 1617667200,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-RB151025/BH92',
      model: {
        name: {
          EN_US: 'Premier B15 Duograph 42',
          ES: 'Premier B15 Duograph 42',
          ZH_HANS: '璞雅文化B15 Duograph腕表42（Premier B15 Duograph 42）',
        },
        slug: 'premier-b15-duograph-42',
      },
      type: {
        EN_US: ['Men', 'Gold', 'Women', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'Oro', 'Mujer', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '金质', '女士', '百年灵自制机芯'],
      },
      universe: 'LAND',
      head_reference: 'RB151025/BH92',
      size: 42.0,
      size_range: '42-43',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/rb1510251b1p1-on-wrist_4e4275ca.png',
      collections: [
        {
          name: 'Premier',
          slug: 'premier',
          id: 'Q29sbGVjdGlvbjo3Mw==',
        },
      ],
      collection: 'Premier',
      collection_id: 'Q29sbGVjdGlvbjo3Mw==',
      com_trace_story: null,
      case: {
        EN_US: '18k red gold | 18KREG',
        ES: 'Oro rojo de 18K | 18KREG',
        ZH_HANS: '18K红金 | 18KREG',
      },
      dial_color: {
        EN_US: 'Black | V-DIAL-COLOR-5686',
        ES: 'Negro | V-DIAL-COLOR-5686',
        ZH_HANS: '黑色 | V-DIAL-COLOR-5686',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:16:04',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1617703200,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'RB1510251B1P1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Premier B15 Duograph 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Premier B15 Duograph 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '璞雅文化B15 Duograph腕表42（Premier B15 Duograph 42）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Premier',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Premier',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: '18k red gold | 18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Oro rojo de 18K | 18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '18K红金 | 18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Black | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Negro | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '黑色 | V-DIAL-COLOR-5686',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Premier B25 Datora 42',
      model_en: 'Premier B25 Datora 42',
      case_en: 'Stainless steel',
      dial_color_en: 'Copper',
      type_en: ['Men', 'Women', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1617703200,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1617703200,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1617703200,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1617703200,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6Mzc5MQ==',
      product_id: 'UHJvZHVjdDozODIx',
      name: {
        EN_US: 'Premier B25 Datora 42',
        ES: 'Premier B25 Datora 42',
        ZH_HANS: '璞雅文化B25 Datora腕表42（Premier B25 Datora 42）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 14500.0,
      price_range: '12000-inf',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/ab2510201k1p1-soldier_64cb492e_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab2510201k1p1-soldier_64cb492e.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736468,
      launch_date: 1617667200,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-AB251020/K536',
      model: {
        name: {
          EN_US: 'Premier B25 Datora 42',
          ES: 'Premier B25 Datora 42',
          ZH_HANS: '璞雅文化B25 Datora腕表42（Premier B25 Datora 42）',
        },
        slug: 'premier-b25-datora-42',
      },
      type: {
        EN_US: ['Men', 'Women', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'Mujer', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '女士', '百年灵自制机芯'],
      },
      universe: 'LAND',
      head_reference: 'AB251020/K536',
      size: 42.0,
      size_range: '42-43',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab2510201k1p1-on-wrist_24cd6ae9.png',
      collections: [
        {
          name: 'Premier',
          slug: 'premier',
          id: 'Q29sbGVjdGlvbjo3Mw==',
        },
      ],
      collection: 'Premier',
      collection_id: 'Q29sbGVjdGlvbjo3Mw==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Copper | V-DIAL-COLO-999',
        ES: 'Cobre | V-DIAL-COLO-999',
        ZH_HANS: '铜色 | V-DIAL-COLO-999',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:16:06',
      },
      widget_is_top_range: true,
      widget_stock_in_wholesaler_ids: [
        'US228516',
        'US102854',
        'US229999',
        'US231131',
        'US102435',
        'US221145',
        'US102977',
        'US102572',
        'US103013',
        'US102367',
        'US102815',
        'US102522',
        'US102515',
        'US102440',
        'US102758',
        'US207515',
        'US102517',
        'US102422',
        'US102477',
        'US102260',
        'US103016',
        'US103039',
        'US103014',
        'US102397',
        'US102306',
        'US102355',
        'US221448',
        'US102288',
        'US102746',
        'US102351',
        'US102875',
        'US102818',
        'US102310',
        'US222013',
        'US102715',
        'US102447',
        'US102718',
        'US102734',
        'US224448',
        'US102379',
        'US102465',
        'US102725',
        'US102399',
        'US102652',
        'US102821',
        'US102717',
        'US102347',
        'US102831',
        'US102366',
        'US102840',
        'US102805',
        'US220584',
        'US103008',
        'US102604',
        'US102764',
        'US102291',
        'US102709',
        'US102532',
        'US102329',
        'US102794',
        'US102368',
        'US102740',
        'US102722',
        'US102468',
        'US102453',
        'US102410',
        'US207516',
        'US102297',
        'US102516',
        'US102553',
        'US102503',
        'US102989',
        'US102421',
        'US102327',
        'US102506',
        'US102414',
        'US103034',
        'US102253',
        'US102978',
        'US102787',
        'US224611',
        'US102314',
        'US102897',
        'US102728',
        'US102538',
        'US231542',
        'US231491',
        'US231826',
        'US230389',
        'US219712',
        'US103023',
        'US102531',
        'US102562',
        'US102889',
        'US102423',
        'US207953',
      ],
      widget_release_ts: 1617703200,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'AB2510201K1P1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Premier B25 Datora 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Premier B25 Datora 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '璞雅文化B25 Datora腕表42（Premier B25 Datora 42）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Premier',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Premier',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Copper | V-DIAL-COLO-999',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Cobre | V-DIAL-COLO-999',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '铜色 | V-DIAL-COLO-999',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Premier B15 Duograph 42',
      model_en: 'Premier B15 Duograph 42',
      case_en: 'Stainless steel',
      dial_color_en: 'Blue',
      type_en: ['Men', 'Women', 'Breitling Manufacture Calibers'],
      com_trace_story_en: null,
      pdp_release_ts: 1617703200,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1617703200,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1617703200,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1617703200,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6MzM0MQ==',
      product_id: 'UHJvZHVjdDozMzYw',
      name: {
        EN_US: 'Premier B15 Duograph 42',
        ES: 'Premier B15 Duograph 42',
        ZH_HANS: '璞雅文化B15 Duograph腕表42（Premier B15 Duograph 42）',
      },
      product_type: 'Watch',
      ecomm_available: true,
      phone_sale_available: true,
      price: 11250.0,
      price_range: '10000-11999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/ab1510171c1p1-soldier_0a52c90c_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab1510171c1p1-soldier_0a52c90c.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736469,
      launch_date: 1617667200,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-AB151017/CA80',
      model: {
        name: {
          EN_US: 'Premier B15 Duograph 42',
          ES: 'Premier B15 Duograph 42',
          ZH_HANS: '璞雅文化B15 Duograph腕表42（Premier B15 Duograph 42）',
        },
        slug: 'premier-b15-duograph-42',
      },
      type: {
        EN_US: ['Men', 'Women', 'Breitling Manufacture Calibers'],
        ES: ['Hombre', 'Mujer', 'CALIBRES DE MANUFACTURA BREITLING'],
        ZH_HANS: ['男士', '女士', '百年灵自制机芯'],
      },
      universe: 'LAND',
      head_reference: 'AB151017/CA80',
      size: 42.0,
      size_range: '42-43',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/ab1510171c1p1-on-wrist_b83893ef.png',
      collections: [
        {
          name: 'Premier',
          slug: 'premier',
          id: 'Q29sbGVjdGlvbjo3Mw==',
        },
      ],
      collection: 'Premier',
      collection_id: 'Q29sbGVjdGlvbjo3Mw==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel | STSTL',
        ES: 'Acero inoxidable | STSTL',
        ZH_HANS: '精钢 | STSTL',
      },
      dial_color: {
        EN_US: 'Blue | V-DIAL-COLOR-5714',
        ES: 'Azul | V-DIAL-COLOR-5714',
        ZH_HANS: '蓝色 | V-DIAL-COLOR-5714',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:16:10',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1617703200,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'AB1510171C1P1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Premier B15 Duograph 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Premier B15 Duograph 42',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '璞雅文化B15 Duograph腕表42（Premier B15 Duograph 42）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Premier',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Premier',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢 | STSTL',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'Blue | V-DIAL-COLOR-5714',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Azul | V-DIAL-COLOR-5714',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '蓝色 | V-DIAL-COLOR-5714',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Chronomat Automatic 36',
      model_en: 'Chronomat Automatic 36',
      case_en: 'Stainless steel & 18k red gold (gem-set)',
      dial_color_en: 'White',
      type_en: ['Women'],
      com_trace_story_en: null,
      pdp_release_ts: 1603882800,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1603882800,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1603882800,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1603882800,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDEzMg==',
      product_id: 'UHJvZHVjdDo0MTgw',
      name: {
        EN_US: 'Chronomat Automatic 36',
        ES: 'Chronomat Automatic 36',
        ZH_HANS: '机械计时自动腕表36（Chronomat Automatic 36）',
      },
      product_type: 'Watch',
      ecomm_available: false,
      phone_sale_available: true,
      price: 13200.0,
      price_range: '12000-inf',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/u10380591a1u1-soldier_c940ee9b_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/u10380591a1u1-soldier_c940ee9b.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736552,
      launch_date: 1603843200,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-U1038059/A829',
      model: {
        name: {
          EN_US: 'Chronomat Automatic 36',
          ES: 'Chronomat Automatic 36',
          ZH_HANS: '机械计时自动腕表36（Chronomat Automatic 36）',
        },
        slug: 'chronomat-automatic-36',
      },
      type: {
        EN_US: ['Women'],
        ES: ['Mujer'],
        ZH_HANS: ['女士'],
      },
      universe: 'LAND',
      head_reference: 'U1038059/A829',
      size: 36.0,
      size_range: '36-37',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/u10380591a1u1-on-wrist_ed09ae4c.png',
      collections: [
        {
          name: 'Chronomat',
          slug: 'chronomat',
          id: 'Q29sbGVjdGlvbjo3Ng==',
        },
      ],
      collection: 'Chronomat',
      collection_id: 'Q29sbGVjdGlvbjo3Ng==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel & 18k red gold (gem-set) | STNSTL_18KREG_GEM',
        ES: 'Acero inoxidable y oro rojo de 18K (engastado) | STNSTL_18KREG_GEM',
        ZH_HANS: '精钢和18K红金（镶嵌宝石） | STNSTL_18KREG_GEM',
      },
      dial_color: {
        EN_US: 'White | V-DIAL-COLOR-5926',
        ES: 'Blanco | V-DIAL-COLOR-5926',
        ZH_HANS: '白色 | V-DIAL-COLOR-5926',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:20:42',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1603882800,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'U10380591A1U1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Chronomat Automatic 36',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Chronomat Automatic 36',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '机械计时自动腕表36（Chronomat Automatic 36）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Chronomat',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Chronomat',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value:
              'Stainless steel & 18k red gold (gem-set) | STNSTL_18KREG_GEM',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value:
              'Acero inoxidable y oro rojo de 18K (engastado) | STNSTL_18KREG_GEM',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢和18K红金（镶嵌宝石） | STNSTL_18KREG_GEM',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'White | V-DIAL-COLOR-5926',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Blanco | V-DIAL-COLOR-5926',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '白色 | V-DIAL-COLOR-5926',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
    {
      name_en: 'Chronomat Automatic 36',
      model_en: 'Chronomat Automatic 36',
      case_en: 'Stainless steel & 18k red gold',
      dial_color_en: 'White',
      type_en: ['Men', 'Women'],
      com_trace_story_en: null,
      pdp_release_ts: 1603882800,
      pdp_expire_ts: 32503680000,
      pdp_preview: true,
      plp_release_ts: 1603882800,
      plp_expire_ts: 32503680000,
      plp_preview: true,
      search_release_ts: 1603882800,
      search_expire_ts: 32503680000,
      search_preview: true,
      components_release_ts: 1603882800,
      components_expire_ts: 32503680000,
      components_preview: true,
      variant_id: 'UHJvZHVjdFZhcmlhbnQ6NDEzOQ==',
      product_id: 'UHJvZHVjdDo0MTg3',
      name: {
        EN_US: 'Chronomat Automatic 36',
        ES: 'Chronomat Automatic 36',
        ZH_HANS: '机械计时自动腕表36（Chronomat Automatic 36）',
      },
      product_type: 'Watch',
      ecomm_available: false,
      phone_sale_available: true,
      price: 9300.0,
      price_range: '9000-9999',
      thumbnail_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/thumbnails/products/u10380101a1u1-soldier_99ada984_thumbnail_512.webp',
      image_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/u10380101a1u1-soldier_99ada984.png',
      currency: 'USD',
      call_to_action: 'ORDER',
      call_to_action_weight: 4,
      call_to_action_for_phone: 'ORDER',
      publication_date: 1706736552,
      launch_date: 1603843200,
      commercial_status: 'In Collection',
      deduplication_key: 'WATCH-U1038010/A822',
      model: {
        name: {
          EN_US: 'Chronomat Automatic 36',
          ES: 'Chronomat Automatic 36',
          ZH_HANS: '机械计时自动腕表36（Chronomat Automatic 36）',
        },
        slug: 'chronomat-automatic-36',
      },
      type: {
        EN_US: ['Men', 'Women'],
        ES: ['Hombre', 'Mujer'],
        ZH_HANS: ['男士', '女士'],
      },
      universe: 'LAND',
      head_reference: 'U1038010/A822',
      size: 36.0,
      size_range: '36-37',
      image_wrist_url:
        'https://www-breitling-pre.eu.saleor.cloud/media/products/u10380101a1u1-on-wrist_d17de12b.png',
      collections: [
        {
          name: 'Chronomat',
          slug: 'chronomat',
          id: 'Q29sbGVjdGlvbjo3Ng==',
        },
      ],
      collection: 'Chronomat',
      collection_id: 'Q29sbGVjdGlvbjo3Ng==',
      com_trace_story: null,
      case: {
        EN_US: 'Stainless steel & 18k red gold | STNSTL_18KREG',
        ES: 'Acero inoxidable y oro rojo de 18K | STNSTL_18KREG',
        ZH_HANS: '精钢和18K红金 | STNSTL_18KREG',
      },
      dial_color: {
        EN_US: 'White | V-DIAL-COLOR-5926',
        ES: 'Blanco | V-DIAL-COLOR-5926',
        ZH_HANS: '白色 | V-DIAL-COLOR-5926',
      },
      marketing_status: ['Core'],
      designer_choice: true,
      _metadata: {
        updated_at_utc: '2025-05-09 19:20:29',
      },
      widget_is_top_range: false,
      widget_stock_in_wholesaler_ids: [],
      widget_release_ts: 1603882800,
      widget_expire_ts: 32503680000,
      widget_preview: true,
      objectID: 'U10380101A1U1',
      _highlightResult: {
        name: {
          EN_US: {
            value: 'Chronomat Automatic 36',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Chronomat Automatic 36',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '机械计时自动腕表36（Chronomat Automatic 36）',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        call_to_action: {
          value: 'ORDER',
          matchLevel: 'none',
          matchedWords: [],
        },
        collections: [
          {
            name: {
              value: 'Chronomat',
              matchLevel: 'none',
              matchedWords: [],
            },
          },
        ],
        collection: {
          value: 'Chronomat',
          matchLevel: 'none',
          matchedWords: [],
        },
        case: {
          EN_US: {
            value: 'Stainless steel & 18k red gold | STNSTL_18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Acero inoxidable y oro rojo de 18K | STNSTL_18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '精钢和18K红金 | STNSTL_18KREG',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
        dial_color: {
          EN_US: {
            value: 'White | V-DIAL-COLOR-5926',
            matchLevel: 'none',
            matchedWords: [],
          },
          ES: {
            value: 'Blanco | V-DIAL-COLOR-5926',
            matchLevel: 'none',
            matchedWords: [],
          },
          ZH_HANS: {
            value: '白色 | V-DIAL-COLOR-5926',
            matchLevel: 'none',
            matchedWords: [],
          },
        },
      },
    },
  ],
  nbHits: 143,
  page: 0,
  nbPages: 3,
  hitsPerPage: 50,
  facets: {
    size: {
      '42.0': 36,
      '44.0': 33,
      '36.0': 28,
      '41.0': 16,
      '46.0': 13,
      '43.0': 6,
      '38.0': 5,
      '40.0': 3,
      '51.0': 2,
      '32.0': 1,
    },
    price: {
      '5250.0': 6,
      '5400.0': 6,
      '5150.0': 5,
      '8550.0': 5,
      '9950.0': 5,
      '3700.0': 4,
      '5500.0': 4,
      '9750.0': 4,
      '5050.0': 3,
      '8650.0': 3,
      '9450.0': 3,
      '9550.0': 3,
      '9700.0': 3,
      '9800.0': 3,
      '10800.0': 2,
      '11250.0': 2,
      '13200.0': 2,
      '13750.0': 2,
      '16200.0': 2,
      '21200.0': 2,
      '26400.0': 2,
      '5450.0': 2,
      '6050.0': 2,
      '6450.0': 2,
      '7300.0': 2,
      '8250.0': 2,
      '8600.0': 2,
      '8900.0': 2,
      '8950.0': 2,
      '9650.0': 2,
    },
    'case.EN_US': {
      'Stainless steel | STSTL': 85,
      'Stainless steel & 18k red gold | STNSTL_18KREG': 15,
      '18k red gold | 18KREG': 14,
      'Breitlight® | BREITL': 6,
      'Stainless steel (gem-set) | STNSTL_GEM': 4,
      'Small scale traceable 18K red gold | BETTERGOLD': 3,
      'Stainless steel & 18k red gold (gem-set) | STNSTL_18KREG_GEM': 3,
      'Stainless steel & 18k white gold | SS_18KWHGLD': 3,
      'Titanium | TITNM': 3,
      'Bronze | BRNZ': 2,
      'Stainless steel & platinum | SS_PLAT': 2,
      'DLC-coated stainless steel | DLCCSSTL': 1,
      'DLC-coated titanium | DLC_CTI': 1,
      'Platinum | PLTNM': 1,
    },
    collection: {
      Chronomat: 46,
      Navitimer: 23,
      Superocean: 18,
      'Superocean Heritage': 18,
      Premier: 10,
      Professional: 8,
      Avenger: 7,
      'Classic AVI': 7,
      'Top Time': 6,
    },
    'type.EN_US': {
      Men: 135,
      'Breitling Manufacture Calibers': 75,
      Women: 73,
      Gold: 18,
      Limited: 8,
      Professional: 8,
      Titanium: 4,
      Blacksteel: 1,
    },
    'dial_color.EN_US': {
      'Black | V-DIAL-COLOR-5686': 32,
      'Blue | V-DIAL-COLOR-5714': 26,
      'Green | V-DIAL-COLOR-5765': 23,
      'Cream | V-DIAL-COLOR-5842': 12,
      'White | V-DIAL-COLOR-5926': 8,
      'Ice blue | V-DIAL-COLOR-1111': 6,
      'Mint green | V-DIAL-COLOR-8888': 6,
      'Anthracite | V-DIAL-COLOR-5664': 5,
      'Copper | V-DIAL-COLO-999': 5,
      'Mother-of-pearl | V-DIAL-COLOR-5791': 5,
      'Silver | V-DIAL-COLOR-5843': 3,
      'Beige | V-DIAL-COLOR-5969': 2,
      'Brown | V-DIAL-COLOR-5723': 2,
      'Red | V-DIAL-COLOR-556644': 2,
      'Bronze | V-DIAL-COLOR-5720': 1,
      'Midnight blue | V-DIAL-COLOR-445566': 1,
      'Orange | V-DIAL-COLOR-5800': 1,
      'Pink mother-of-pearl | V-DIAL-COLOR-6666': 1,
      'Turquoise | V-DIAL-COLOR-9876': 1,
      'Yellow | VDIALCOLOR9999': 1,
    },
  },
  facets_stats: {
    size: {
      min: 32,
      max: 51,
      avg: 41.4545,
      sum: 5928,
    },
    price: {
      min: 3400,
      max: 41950,
      avg: 10710.8,
      sum: 1.4888e6,
    },
  },
  exhaustiveFacetsCount: true,
  exhaustiveNbHits: true,
  exhaustiveTypo: true,
  exhaustive: {
    facetsCount: true,
    nbHits: true,
    typo: true,
  },
  query: '',
  params:
    'analytics=true&analyticsTags=%5B%22platform%3Aweb%22%2C%22product%3Awatches%22%2C%22page%3Alisting%22%2C%22context%3Aall-watches%22%5D&clickAnalytics=true&distinct=true&enablePersonalization=true&facetingAfterDistinct=true&facets=%5B%22case.EN_US%22%2C%22collection%22%2C%22dial_color.EN_US%22%2C%22objectID%22%2C%22price%22%2C%22size%22%2C%22type.EN_US%22%5D&filters=product_type%3AWatch%20AND%20plp_release_ts%20%3C%201747407771%20AND%20plp_expire_ts%20%3E%201747407771&highlightPostTag=__%2Fais-highlight__&highlightPreTag=__ais-highlight__&maxValuesPerFacet=30&page=0&query=&restrictSearchableAttributes=%5B%22objectID%22%2C%22name%22%5D&tagFilters=&userToken=anonymous-7cfefc6d-10ff-4a2c-8dc1-58c0fd4e6164',
  index: 'PRE.PRODUCT.us-usd',
  queryID: '170968aa2e4f898e370518488ffbc2bf',
  _automaticInsights: true,
  renderingContent: {
    facetOrdering: {
      facets: {
        order: [
          'case.EN_US',
          'case.ES',
          'case.ZH_HANS',
          'collections.name',
          'size',
          'type.EN_US',
          'type.ES',
          'type.ZH_HANS',
          'color.EN_US',
          'color.ES',
          'color.ZH_HANS',
          'material.EN_US',
          'material.ES',
          'material.ZH_HANS',
          'dial_color.EN_US',
          'dial_color.ES',
          'dial_color.ZH_HANS',
          'lug_size',
          'distance_between_horns.EN_US',
          'distance_between_horns.ES',
          'distance_between_horns.ZH_HANS',
          'strap_length.EN_US',
          'strap_length.ES',
          'strap_length.ZH_HANS',
          'buckle_type.EN_US',
          'buckle_type.ES',
          'buckle_type.ZH_HANS',
          'price',
        ],
      },
      values: {
        'buckle_type.EN_US': {
          sortRemainingBy: 'count',
        },
        'buckle_type.ES': {
          sortRemainingBy: 'count',
        },
        'buckle_type.ZH_HANS': {
          sortRemainingBy: 'count',
        },
        'case.EN_US': {
          sortRemainingBy: 'count',
        },
        'case.ES': {
          sortRemainingBy: 'count',
        },
        'case.ZH_HANS': {
          sortRemainingBy: 'count',
        },
        'collections.name': {
          sortRemainingBy: 'count',
        },
        'color.EN_US': {
          sortRemainingBy: 'count',
        },
        'color.ES': {
          sortRemainingBy: 'count',
        },
        'color.ZH_HANS': {
          sortRemainingBy: 'count',
        },
        'dial_color.EN_US': {
          sortRemainingBy: 'count',
        },
        'dial_color.ES': {
          sortRemainingBy: 'count',
        },
        'dial_color.ZH_HANS': {
          sortRemainingBy: 'count',
        },
        'distance_between_horns.EN_US': {
          sortRemainingBy: 'count',
        },
        'distance_between_horns.ES': {
          sortRemainingBy: 'count',
        },
        'distance_between_horns.ZH_HANS': {
          sortRemainingBy: 'count',
        },
        lug_size: {
          sortRemainingBy: 'count',
        },
        'material.EN_US': {
          sortRemainingBy: 'count',
        },
        'material.ES': {
          sortRemainingBy: 'count',
        },
        'material.ZH_HANS': {
          sortRemainingBy: 'count',
        },
        price: {
          sortRemainingBy: 'count',
        },
        size: {
          sortRemainingBy: 'count',
        },
        'strap_length.EN_US': {
          sortRemainingBy: 'count',
        },
        'strap_length.ES': {
          sortRemainingBy: 'count',
        },
        'strap_length.ZH_HANS': {
          sortRemainingBy: 'count',
        },
        'type.EN_US': {
          sortRemainingBy: 'count',
        },
        'type.ES': {
          sortRemainingBy: 'count',
        },
        'type.ZH_HANS': {
          sortRemainingBy: 'count',
        },
      },
    },
  },
  processingTimeMS: 2,
  processingTimingsMS: {
    _request: {
      roundTrip: 80,
    },
    afterFetch: {
      format: {
        total: 2,
      },
    },
    getIdx: {
      load: {
        total: 1,
      },
      total: 1,
    },
    total: 2,
  },
  serverTimeMS: 5,
};
